
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7dhmX", function(module, exports) {
$parcel$export(module.exports, "COMPASS_DEFAULT_BILLING_CYCLE", function () { return $50757f59ceb0cbe4$export$2c789441f8bab310; });
$parcel$export(module.exports, "COMPASS_DEFAULT_UNIT_COUNT", function () { return $50757f59ceb0cbe4$export$887bc0e84eafd3c; });
$parcel$export(module.exports, "COMPASS_MIN_ENTERPRISE_USER_COUNT", function () { return $50757f59ceb0cbe4$export$862352663e0ac9d7; });
$parcel$export(module.exports, "compassOfferingSkus", function () { return $50757f59ceb0cbe4$export$f93fb5caff8c778a; });
$parcel$export(module.exports, "compassOfferingSkusArray", function () { return $50757f59ceb0cbe4$export$74a0fd94f40ef5c5; });
$parcel$export(module.exports, "compassPlanLimitConfigs", function () { return $50757f59ceb0cbe4$export$4df3b64d28e0d138; });
$parcel$export(module.exports, "compassBillingCycleConfig", function () { return $50757f59ceb0cbe4$export$e0b3f0eba764d747; });
const $50757f59ceb0cbe4$export$2c789441f8bab310 = 'MONTHLY';
const $50757f59ceb0cbe4$export$887bc0e84eafd3c = 300;
const $50757f59ceb0cbe4$export$862352663e0ac9d7 = Infinity;
const $50757f59ceb0cbe4$export$f93fb5caff8c778a = {
    free: 'compass-free',
    standard: 'compass-standard',
    premium: 'compass-premium-sku'
};
const $50757f59ceb0cbe4$export$74a0fd94f40ef5c5 = Object.values($50757f59ceb0cbe4$export$f93fb5caff8c778a);
const $50757f59ceb0cbe4$export$4df3b64d28e0d138 = [
    {
        planName: 'Free',
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.free,
        recommendationLimit: 0,
        signupLimit: 3
    },
    {
        planName: 'Standard',
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.standard,
        recommendationLimit: 3,
        signupLimit: 35000
    },
    {
        planName: 'Premium',
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.premium,
        recommendationLimit: 250,
        signupLimit: 35000
    }
];
const $50757f59ceb0cbe4$export$e0b3f0eba764d747 = {
    monthly: true,
    annual: true
};

});

parcelRegister("44C4o", function(module, exports) {
$parcel$export(module.exports, "GUARD_DEFAULT_BILLING_CYCLE", function () { return $757a4e832c1a582d$export$9be98af08cc25cad; });
$parcel$export(module.exports, "GUARD_DEFAULT_UNIT_COUNT", function () { return $757a4e832c1a582d$export$d28097ea69640bd5; });
$parcel$export(module.exports, "GUARD_MIN_ENTERPRISE_USER_COUNT", function () { return $757a4e832c1a582d$export$13b500e201e8b319; });
$parcel$export(module.exports, "guardOfferingSkus", function () { return $757a4e832c1a582d$export$91a420e9c7eb7c83; });
$parcel$export(module.exports, "guardOfferingSkusArray", function () { return $757a4e832c1a582d$export$159558c2b3d66b11; });
$parcel$export(module.exports, "guardPlanLimitConfigs", function () { return $757a4e832c1a582d$export$a2329ae21ff2ff84; });
$parcel$export(module.exports, "guardBillingCycleConfig", function () { return $757a4e832c1a582d$export$129a445945b6d9b3; });
const $757a4e832c1a582d$export$9be98af08cc25cad = 'MONTHLY';
const $757a4e832c1a582d$export$d28097ea69640bd5 = 100;
const $757a4e832c1a582d$export$13b500e201e8b319 = Infinity;
const $757a4e832c1a582d$export$91a420e9c7eb7c83 = {
    standard: 'atlassian-access-standard-sku',
    premium: 'atlassian-guard-premium-addon-sku'
};
const $757a4e832c1a582d$export$159558c2b3d66b11 = Object.values($757a4e832c1a582d$export$91a420e9c7eb7c83);
const $757a4e832c1a582d$export$a2329ae21ff2ff84 = [
    {
        planName: 'Standard',
        offeringSku: $757a4e832c1a582d$export$91a420e9c7eb7c83.standard,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: 'Premium',
        offeringSku: $757a4e832c1a582d$export$91a420e9c7eb7c83.premium,
        recommendationLimit: 99,
        signupLimit: 50000
    }
];
const $757a4e832c1a582d$export$129a445945b6d9b3 = {
    monthly: true,
    annual: true
};

});

parcelRegister("4utnL", function(module, exports) {
$parcel$export(module.exports, "LOOM_DEFAULT_BILLING_CYCLE", function () { return $567bad4c99b6ec03$export$501dc9dfd5b2bde4; });
$parcel$export(module.exports, "LOOM_DEFAULT_UNIT_COUNT", function () { return $567bad4c99b6ec03$export$2aa1a93e0ac00fc; });
$parcel$export(module.exports, "LOOM_MIN_ENTERPRISE_USER_COUNT", function () { return $567bad4c99b6ec03$export$2a2f7d7a7ae18850; });
$parcel$export(module.exports, "loomOfferingSkus", function () { return $567bad4c99b6ec03$export$a64578a63428ae96; });
$parcel$export(module.exports, "loomOfferingSkusArray", function () { return $567bad4c99b6ec03$export$9f95f1c871571078; });
$parcel$export(module.exports, "loomPlanLimitConfigs", function () { return $567bad4c99b6ec03$export$ed1379ed8713d252; });
$parcel$export(module.exports, "loomBillingCycleConfig", function () { return $567bad4c99b6ec03$export$d2bfeac6f7899675; });
const $567bad4c99b6ec03$export$501dc9dfd5b2bde4 = 'MONTHLY';
const $567bad4c99b6ec03$export$2aa1a93e0ac00fc = 100;
const $567bad4c99b6ec03$export$2a2f7d7a7ae18850 = Infinity;
const $567bad4c99b6ec03$export$a64578a63428ae96 = {
    free: 'loom-free-sku',
    business: 'loom-business-sku',
    businessPlusAi: 'loom-business-ai-sku',
    enterprise: 'loom-enterprise-sku'
};
const $567bad4c99b6ec03$export$9f95f1c871571078 = Object.values($567bad4c99b6ec03$export$a64578a63428ae96);
const $567bad4c99b6ec03$export$ed1379ed8713d252 = [
    {
        planName: 'Free',
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.free,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: 'Business',
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.business,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: 'Business + AI',
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.businessPlusAi,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: 'Enterprise',
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.enterprise,
        recommendationLimit: Infinity,
        signupLimit: 50000
    }
];
const $567bad4c99b6ec03$export$d2bfeac6f7899675 = {
    monthly: true,
    annual: true
};

});

parcelRegister("hGYMM", function(module, exports) {
$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $45ceb3dd2bb22ad6$export$c00ddd271304729a; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $45ceb3dd2bb22ad6$export$27579c7f06007c25; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a; });
$parcel$export(module.exports, "strategyCollectionOfferingSkus", function () { return $45ceb3dd2bb22ad6$export$8427e2db10f569be; });
$parcel$export(module.exports, "strategyCollectionOfferingSkusArray", function () { return $45ceb3dd2bb22ad6$export$3b4c7d53b38ef615; });
$parcel$export(module.exports, "strategyCollectionPlanLimitConfigs", function () { return $45ceb3dd2bb22ad6$export$bc4927fbd68771ac; });
$parcel$export(module.exports, "strategyCollectionBillingCycleConfig", function () { return $45ceb3dd2bb22ad6$export$2225b2a65811f064; });
const $45ceb3dd2bb22ad6$export$c00ddd271304729a = 'ANNUAL';
const $45ceb3dd2bb22ad6$export$27579c7f06007c25 = 50;
const $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a = 50;
const $45ceb3dd2bb22ad6$export$8427e2db10f569be = {
    enterprise: 'strategy-collection-enterprise-sku'
};
const $45ceb3dd2bb22ad6$export$3b4c7d53b38ef615 = Object.values($45ceb3dd2bb22ad6$export$8427e2db10f569be);
const $45ceb3dd2bb22ad6$export$bc4927fbd68771ac = [
    {
        planName: 'Enterprise',
        offeringSku: $45ceb3dd2bb22ad6$export$8427e2db10f569be.enterprise,
        recommendationLimit: 2000,
        signupLimit: 2000,
        minUnitCount: $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a
    }
];
const $45ceb3dd2bb22ad6$export$2225b2a65811f064 = {
    monthly: false,
    annual: true
};

});

parcelRegister("jE3Ci", function(module, exports) {
$parcel$export(module.exports, "Lozenge", function () { return $f71e5bcdfd5682cc$export$a31cbe1bf5463979; });
/* lozenge.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $i4BST = parcelRequire("i4BST");
const $f71e5bcdfd5682cc$var$appearanceColors = {
    blue: {
        backgroundColor: (0, $kbpa7.wacToken)('color.extended.blue100'),
        color: (0, $kbpa7.wacToken)('color.extended.blue800')
    },
    neutral: {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        color: "var(--ds-text-subtle, #505258)"
    },
    saffron: {
        backgroundColor: (0, $kbpa7.wacToken)('color.extended.saffron100'),
        color: (0, $kbpa7.wacToken)('color.extended.saffron800')
    },
    lime: {
        backgroundColor: (0, $kbpa7.wacToken)('color.extended.lime100'),
        color: (0, $kbpa7.wacToken)('color.extended.lime800')
    },
    purple: {
        backgroundColor: (0, $kbpa7.wacToken)('color.extended.purple100'),
        color: (0, $kbpa7.wacToken)('color.extended.purple800')
    },
    danger: {
        backgroundColor: "var(--ds-background-danger, #FFEBE6)",
        color: (0, $kbpa7.wacToken)('color.secondary.red')
    }
};
const $f71e5bcdfd5682cc$export$a31cbe1bf5463979 = ({ appearance: appearance = 'neutral', text: text })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    if (!text) return null;
    const colors = $f71e5bcdfd5682cc$var$appearanceColors[appearance] ?? $f71e5bcdfd5682cc$var$appearanceColors.neutral;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _zulp19bv _18zrftgi _y3gn1h6o _ect4z4z1 _k48pbfng _1dyznl7k _1p1dangw _p12fuuw1 _vchhusvi _1o9zidpf _1bsb1ns9 _bfhk1a2e _syaz10mv",
            isWacRefresh ? "_2rko1l7b _1wyb1crf _vwz47vkz _3p1cdlk8 _py5of6fq _fz897vkz _1ol9f6fq" : "_1wyb1skh _vwz47vkz _2rkogktf"
        ]),
        style: {
            '--lozenge-bg': colors.backgroundColor,
            '--lozenge-color': colors.color,
            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
        },
        children: text
    });
};
const $f71e5bcdfd5682cc$var$lozengeStyles = null;
const $f71e5bcdfd5682cc$var$nonRefreshLozengeStyles = null;
const $f71e5bcdfd5682cc$var$refreshLozengeStyles = null;

});

parcelRegister("g3AHF", function(module, exports) {
$parcel$export(module.exports, "Expand", function () { return $01c56c8250903469$export$49bd1dfb0ad29c40; });
/* expand.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $Lp2P8 = parcelRequire("Lp2P8");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $jE3Ci = parcelRequire("jE3Ci");
const $01c56c8250903469$var$containerStyles = null;
// CSS to hide the default summary marker
const $01c56c8250903469$var$buttonStyles = null;
const $01c56c8250903469$export$49bd1dfb0ad29c40 = ({ children: children, label: label, expandedLabelText: expandedLabelText, eventDataName: eventDataName = 'expand', actionSubject: actionSubject = 'expand', boldLabel: boldLabel, chevronColor: chevronColor, isExpanded: isExpanded = false, lozengeText: lozengeText, lozengeAppearance: lozengeAppearance = 'blue' })=>{
    const [disableTransition, setDisableTransition] = (0, $1oC0p.useState)(true);
    const [expanded, setExpanded] = (0, $1oC0p.useState)(isExpanded);
    const [height, setHeight] = (0, $1oC0p.useState)(()=>{
        // "auto" if expanded on mount to avoid transition
        return isExpanded ? 'auto' : '0px';
    });
    const contentRef = (0, $1oC0p.useRef)(null);
    const contentId = (0, $1oC0p.useId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    (0, $1oC0p.useEffect)(()=>{
        setExpanded(isExpanded);
        if (contentRef.current && isExpanded) setHeight(contentRef.current.scrollHeight + 'px');
        else if (!isExpanded && contentRef.current) setHeight('0px');
    }, [
        isExpanded
    ]);
    const handleToggle = ()=>{
        if (disableTransition) setDisableTransition(false);
        if (!expanded && contentRef.current) {
            setHeight(contentRef.current.scrollHeight + 'px');
            setExpanded(true);
        } else if (expanded && contentRef.current) {
            setHeight(contentRef.current.scrollHeight + 'px'); // set to current height
            setTimeout(()=>setHeight('0px'), 10); // next tick to trigger transition
            setExpanded(false);
        }
        if (eventDataName) {
            const expandedDirectionLabel = !expanded ? 'open' : 'close';
            createAnalyticsEvent({
                eventType: 'ui',
                eventComponent: 'button',
                action: 'clicked',
                actionSubject: actionSubject ?? 'expand',
                source: 'expand-button',
                attributes: {
                    name: eventDataName,
                    label: expandedDirectionLabel,
                    direction: expandedDirectionLabel
                }
            }).fire();
        }
    };
    const handleTransitionEnd = ()=>{
        if (expanded && contentRef.current) setHeight('auto');
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpftgi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                type: "button",
                "data-testid": "expand-button",
                onClick: handleToggle,
                "aria-expanded": expanded,
                "aria-controls": contentId,
                className: (0, $2jatx.default)([
                    "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _1e0c1txw _zulp1b66 _1ygb1qgu _1ah3yh40"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_4t3i1tcg _1bsb1tcg _t9ec1g85 _v564aob1",
                            chevronColor && "_syazu2ay"
                        ]),
                        style: {
                            "--_vcjhmp": (0, $6ZVlx.default)(expanded ? 'rotate(90deg)' : 'rotate(0deg)'),
                            "--_r33mjn": (0, $6ZVlx.default)(disableTransition ? 'none' : 'transform 0.1s ease-in-out'),
                            "--_1em7f5x": (0, $6ZVlx.default)((0, $kbpa7.wacToken)(chevronColor))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Lp2P8))), {
                            label: "",
                            spacing: "spacious"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfht94y _y3gn1e5h",
                                "body-sm"
                            ]),
                            style: {
                                fontWeight: boldLabel ? 700 : 'inherit'
                            },
                            children: [
                                expanded && expandedLabelText ? expandedLabelText : label,
                                ' ',
                                lozengeText && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                                    text: lozengeText,
                                    appearance: lozengeAppearance
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-testid": "expand-content",
                id: contentId,
                ref: contentRef,
                onTransitionEnd: handleTransitionEnd,
                "aria-hidden": !expanded,
                className: (0, $2jatx.default)([
                    "_1reo15vq _18m915vq _v5641vd9 _4t3imry4 _bozg19zt"
                ]),
                style: {
                    "--_1gp6mdv": (0, $6ZVlx.default)(disableTransition ? '0s' : '0.15s ease-in-out'),
                    "--_roksyz": (0, $6ZVlx.default)(height)
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "body-sm",
                        children: children
                    })
                })
            })
        ]
    });
};

});

parcelRegister("hfydu", function(module, exports) {
$parcel$export(module.exports, "DwellTimeContext", function () { return $a244796123281e74$export$823a77756167cdd0; });
$parcel$export(module.exports, "DwellTimeContextProvider", function () { return $a244796123281e74$export$f8e52a5bfd9c0a72; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $aj5Hv = parcelRequire("aj5Hv");

var $jiOui = parcelRequire("jiOui");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $g5vAg = parcelRequire("g5vAg");

var $42SNp = parcelRequire("42SNp");
const $a244796123281e74$export$823a77756167cdd0 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
// Emit boundaries (seconds): 2, 3, 5, 5, 5, 10 → cumulative 2, 5, 10, 15, 20, 30s.
// Final value repeats indefinitely.
const $a244796123281e74$var$DEFAULT_DWELL_INTERVAL_SCHEDULE = {
    intervals: [
        2,
        3,
        5,
        5,
        5,
        10
    ]
};
const $a244796123281e74$export$f8e52a5bfd9c0a72 = (props)=>{
    const { enabled: enabledProp, schedule: schedule = $a244796123281e74$var$DEFAULT_DWELL_INTERVAL_SCHEDULE, idleTimeoutSeconds: idleTimeoutSeconds, trackability: trackability, onEmit: onEmitOverride, children: children } = props;
    const enabledGate = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacDwellTimeTracking);
    // Dwell tracking only runs on routes explicitly whitelisted in the
    // `dwell-time-enabled-routes` dynamic config. Empty/missing allowlist =>
    // no routes emit (opt-in). The current route is derived via `parseRoute`
    // (locale-stripped, leading-slash) — the same canonical page path used by
    // the other WAC route-list configs in `resolve-page-props.ts`, so the
    // whitelist keys off the same path GASv3/metrics report. Whitelist entries
    // support `/*` glob suffixes (e.g. `/software/jira/*`).
    // Config: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/dwell-time-enabled-routes
    const enabledRoutes = (0, $jiOui.getDynamicConfig)({
        config: (0, $aj5Hv.dynamicConfigManifest).dwellTimeEnabledRoutes,
        defaultValue: []
    });
    const isRouteEnabled = (0, $g5vAg.isRouteInPatternList)(enabledRoutes);
    const enabled = enabledProp && enabledGate && isRouteEnabled;
    const value = (0, $1oC0p.useMemo)(()=>({
            enabled: enabled
        }), [
        enabled
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const defaultOnEmit = (0, $1oC0p.useCallback)((payload)=>{
        const path = typeof window !== 'undefined' ? window.location.pathname : 'unknown';
        createAnalyticsEvent({
            name: 'dwellTimeIntervalElapsed',
            actionSubject: 'dwellTimeInterval',
            action: 'elapsed',
            eventType: 'track',
            source: path,
            attributes: {
                sessionId: payload.sessionId,
                sessionStartedAt: payload.sessionStartedAt,
                intervalEndedAt: payload.intervalEndedAt,
                stepIndex: payload.stepIndex,
                durations: payload.durations,
                path: path
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onEmit = onEmitOverride ?? defaultOnEmit;
    const onEmitRef = (0, $1oC0p.useRef)(onEmit);
    onEmitRef.current = onEmit;
    (0, $1oC0p.useEffect)(()=>{
        if (!enabled) return undefined;
        const tracker = new (0, $42SNp.DwellTracker)({
            schedule: schedule,
            idleTimeoutSeconds: idleTimeoutSeconds,
            trackability: trackability,
            onEmit: (payload)=>onEmitRef.current(payload)
        });
        tracker.start();
        return ()=>tracker.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- non-`enabled` options are intentionally captured once.
    }, [
        enabled
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($a244796123281e74$export$823a77756167cdd0.Provider, {
        value: value,
        children: children
    });
};

});
parcelRegister("g5vAg", function(module, exports) {
$parcel$export(module.exports, "isRouteInPatternList", function () { return $4fa59628fab8c2ff$export$e4d60b2209adab32; });

var $hu7gH = parcelRequire("hu7gH");
const $4fa59628fab8c2ff$export$7bbf819073319b08 = (route, pattern)=>{
    if (pattern.endsWith('/*')) {
        const prefix = pattern.slice(0, -2);
        return route === prefix || route.startsWith(`${prefix}/`);
    }
    return route === pattern;
};
const $4fa59628fab8c2ff$export$4df88a88032fa293 = (location)=>{
    const resolvedLocation = location ?? (typeof globalThis !== 'undefined' ? globalThis.location : undefined);
    if (!resolvedLocation) return '';
    return `/${(0, $hu7gH.parseRoute)(resolvedLocation).path}`;
};
const $4fa59628fab8c2ff$export$e4d60b2209adab32 = (patterns, location)=>{
    const route = $4fa59628fab8c2ff$export$4df88a88032fa293(location);
    if (!route) return false;
    return patterns.some((pattern)=>$4fa59628fab8c2ff$export$7bbf819073319b08(route, pattern));
};

});

parcelRegister("42SNp", function(module, exports) {
$parcel$export(module.exports, "DwellTracker", function () { return $e05ccb7bf12f0466$export$b52d12393c27b8c2; });

var $h8tqd = parcelRequire("h8tqd");

var $1awGg = parcelRequire("1awGg");

var $jJju2 = parcelRequire("jJju2");

var $g14wK = parcelRequire("g14wK");

var $76bMJ = parcelRequire("76bMJ");

var $3yqd8 = parcelRequire("3yqd8");

var $2AizJ = parcelRequire("2AizJ");

var $9XWaQ = parcelRequire("9XWaQ");

var $jewWt = parcelRequire("jewWt");

var $cyd5Y = parcelRequire("cyd5Y");

var $kxdeC = parcelRequire("kxdeC");

var $dfN1H = parcelRequire("dfN1H");
const $e05ccb7bf12f0466$var$DEFAULT_IDLE_TIMEOUT_SECONDS = 60;
const $e05ccb7bf12f0466$var$defaultClock = ()=>Date.now();
class $e05ccb7bf12f0466$export$b52d12393c27b8c2 {
    constructor(options){
        this.spansCache = (0, $2AizJ.createElementDwellSpansCache)();
        this.sessionState = (0, $kxdeC.createDwellSessionState)();
        this.cursor = (0, $cyd5Y.createIntervalScheduleCursor)();
        this.idleState = (0, $jewWt.createIdleState)();
        this.trackerRunning = false;
        this.start = ()=>{
            if (this.trackerRunning) return;
            this.trackerRunning = true;
            this.domObserver.start();
            this.activityListener.start();
            this.browserLifecycle.start();
            this.idlePoller.start();
            this.openSession();
        };
        this.stop = ()=>{
            if (!this.trackerRunning) return;
            this.trackerRunning = false;
            this.closeSession();
            this.domObserver.stop();
            this.activityListener.stop();
            this.browserLifecycle.stop();
            this.idlePoller.stop();
        };
        this.openSession = ()=>{
            if ((0, $kxdeC.isDwellSessionActive)(this.sessionState)) return;
            const now = this.clock();
            (0, $kxdeC.startDwellSession)(this.sessionState, this.generateId(), now);
            (0, $cyd5Y.resetIntervalScheduleCursor)(this.cursor);
            (0, $jewWt.recordActivity)(this.idleState, now);
            // Rebase any spans that are still active from a previous session so
            // their entrance timestamps start at this session's opening moment.
            // Without this, the first interval would emit the full time-since-
            // last-close, including any idle/away gap.
            (0, $2AizJ.rolloverActiveElementDwellSpans)(this.spansCache, now);
            this.intervalLoop = new (0, $76bMJ.IntervalLoop)(this.schedule, this.cursor, (stepIndex)=>{
                const intervalEndedAt = this.clock();
                this.flushEmit(intervalEndedAt, stepIndex);
                (0, $2AizJ.rolloverActiveElementDwellSpans)(this.spansCache, intervalEndedAt);
            });
            this.intervalLoop.start();
        };
        this.closeSession = ()=>{
            if (!(0, $kxdeC.isDwellSessionActive)(this.sessionState)) return;
            const intervalEndedAt = this.clock();
            this.flushEmit(intervalEndedAt, this.cursor.stepIndex);
            this.intervalLoop?.stop();
            this.intervalLoop = undefined;
            (0, $kxdeC.endDwellSession)(this.sessionState);
            // Leave active spans alone — they'll be rebased when (if) a new
            // session opens. Drop completed spans now since they've been emitted.
            this.spansCache.completed = [];
            (0, $cyd5Y.resetIntervalScheduleCursor)(this.cursor);
        };
        this.handleSessionEnd = ()=>this.closeSession();
        this.handleSessionRestart = ()=>this.openSession();
        this.flushEmit = (intervalEndedAt, stepIndex)=>{
            const payload = (0, $9XWaQ.getEmitPayload)(this.sessionState, this.spansCache, intervalEndedAt, stepIndex);
            if (payload === null) return;
            try {
                this.onEmit(payload);
            } catch (err) {
                console.error('[dwell-time] emit handler threw:', err);
            }
        };
        this.schedule = options.schedule;
        this.onEmit = options.onEmit;
        this.clock = options.clock ?? $e05ccb7bf12f0466$var$defaultClock;
        this.generateId = options.generateId ?? (0, $dfN1H.generateSessionId);
        this.idleTimeoutSeconds = options.idleTimeoutSeconds ?? $e05ccb7bf12f0466$var$DEFAULT_IDLE_TIMEOUT_SECONDS;
        this.trackability = $e05ccb7bf12f0466$var$normalizeTrackability(options.trackability);
        // Construct the persistent effects eagerly. Each one is inert until
        // its `start` is called from `tracker.start()`.
        this.domObserver = new (0, $jJju2.DomObserver)(this.spansCache, this.trackability, this.clock);
        this.activityListener = new (0, $h8tqd.ActivityListener)(this.idleState, this.clock);
        this.browserLifecycle = new (0, $1awGg.BrowserLifecycleListeners)({
            onSessionEnd: this.handleSessionEnd,
            onSessionRestart: this.handleSessionRestart
        });
        this.idlePoller = new (0, $g14wK.IdlePoller)(this.idleState, {
            idleTimeoutMs: this.idleTimeoutSeconds * 1000,
            pollIntervalMs: options.idlePollerIntervalMs,
            clock: this.clock,
            onIdle: ()=>this.closeSession(),
            onActive: ()=>this.openSession()
        });
    }
}
function $e05ccb7bf12f0466$var$normalizeTrackability(trackability) {
    if (trackability === undefined) return [
        (0, $3yqd8.defaultTrackability)
    ];
    return Array.isArray(trackability) ? trackability : [
        trackability
    ];
}

});
parcelRegister("h8tqd", function(module, exports) {
$parcel$export(module.exports, "ActivityListener", function () { return $2a16eb342dbac022$export$653a82d4e3c8af65; });

var $jewWt = parcelRequire("jewWt");
const $2a16eb342dbac022$var$ACTIVITY_EVENTS = [
    'pointermove',
    'mousemove',
    'keydown',
    'scroll',
    'click',
    'pointerdown'
];
class $2a16eb342dbac022$export$653a82d4e3c8af65 {
    constructor(state, clock){
        this.started = false;
        this.start = ()=>{
            if (this.started) return;
            if (typeof document === 'undefined') {
                this.started = true;
                return;
            }
            this.started = true;
            this.handleActivity = ()=>{
                (0, $jewWt.recordActivity)(this.state, this.clock());
            };
            const handler = this.handleActivity;
            $2a16eb342dbac022$var$ACTIVITY_EVENTS.forEach((evt)=>{
                document.addEventListener(evt, handler, {
                    passive: true
                });
            });
        };
        this.stop = ()=>{
            if (!this.started) return;
            this.started = false;
            const handler = this.handleActivity;
            if (handler !== undefined) {
                $2a16eb342dbac022$var$ACTIVITY_EVENTS.forEach((evt)=>{
                    document.removeEventListener(evt, handler);
                });
                this.handleActivity = undefined;
            }
        };
        this.state = state;
        this.clock = clock;
    }
}

});
parcelRegister("jewWt", function(module, exports) {
$parcel$export(module.exports, "createIdleState", function () { return $73fd652edb98a7a1$export$1272f3ff7e83e1a2; });
$parcel$export(module.exports, "recordActivity", function () { return $73fd652edb98a7a1$export$9addc862983bb20b; });
$parcel$export(module.exports, "updateIdleStateAt", function () { return $73fd652edb98a7a1$export$4e0d7bb1ad57dcdb; });
function $73fd652edb98a7a1$export$1272f3ff7e83e1a2() {
    return {
        lastActivityAt: null,
        isIdle: false
    };
}
function $73fd652edb98a7a1$export$9addc862983bb20b(state, timestamp) {
    state.lastActivityAt = timestamp;
    state.isIdle = false;
}
function $73fd652edb98a7a1$export$d9d1ca76cbd41137(state, now, idleTimeoutMs) {
    if (state.lastActivityAt === null) return false;
    return now - state.lastActivityAt >= idleTimeoutMs;
}
function $73fd652edb98a7a1$export$4e0d7bb1ad57dcdb(state, now, idleTimeoutMs) {
    state.isIdle = $73fd652edb98a7a1$export$d9d1ca76cbd41137(state, now, idleTimeoutMs);
    return state.isIdle;
}
function $73fd652edb98a7a1$export$39a275e858742288(state) {
    state.lastActivityAt = null;
    state.isIdle = false;
}

});


parcelRegister("1awGg", function(module, exports) {
$parcel$export(module.exports, "BrowserLifecycleListeners", function () { return $44f23eed445fb4b5$export$5a070be5ed0156f6; });
const $44f23eed445fb4b5$var$SESSION_END_WIN_EVENTS = [
    'pagehide',
    'beforeunload',
    'unload'
];
const $44f23eed445fb4b5$var$SESSION_RESTART_WIN_EVENTS = [
    'pageshow',
    'focus'
];
class $44f23eed445fb4b5$export$5a070be5ed0156f6 {
    constructor(handlers){
        this.started = false;
        this.teardown = [];
        this.start = ()=>{
            if (this.started) return;
            if (typeof document === 'undefined' || typeof window === 'undefined') {
                this.started = true;
                return;
            }
            this.started = true;
            // Single visibilitychange listener that dispatches to the appropriate
            // callback based on the current visibilityState.
            const handleVisibility = ()=>{
                if (document.visibilityState === 'hidden') this.handlers.onSessionEnd('visibilitychange');
                else if (document.visibilityState === 'visible') this.handlers.onSessionRestart('visibilitychange');
            };
            document.addEventListener('visibilitychange', handleVisibility);
            this.teardown.push(()=>document.removeEventListener('visibilitychange', handleVisibility));
            $44f23eed445fb4b5$var$SESSION_END_WIN_EVENTS.forEach((evt)=>{
                const handler = ()=>this.handlers.onSessionEnd(evt);
                window.addEventListener(evt, handler);
                this.teardown.push(()=>window.removeEventListener(evt, handler));
            });
            // `blur` fires for many non-session-ending reasons (iframe focus, native
            // dropdowns, alert/print dialogs). Defer one microtask and confirm the
            // window genuinely lost focus before treating it as a session end.
            const handleBlur = (event)=>{
                if (event.target !== window) return;
                queueMicrotask(()=>{
                    if (!document.hasFocus()) this.handlers.onSessionEnd('blur');
                });
            };
            window.addEventListener('blur', handleBlur);
            this.teardown.push(()=>window.removeEventListener('blur', handleBlur));
            $44f23eed445fb4b5$var$SESSION_RESTART_WIN_EVENTS.forEach((evt)=>{
                const handler = ()=>this.handlers.onSessionRestart(evt);
                window.addEventListener(evt, handler);
                this.teardown.push(()=>window.removeEventListener(evt, handler));
            });
        };
        this.stop = ()=>{
            if (!this.started) return;
            this.started = false;
            this.teardown.forEach((off)=>off());
            this.teardown = [];
        };
        this.handlers = handlers;
    }
}

});

parcelRegister("jJju2", function(module, exports) {
$parcel$export(module.exports, "DomObserver", function () { return $403152b531bdd98a$export$1799337af8e4206c; });

var $2AizJ = parcelRequire("2AizJ");
const $403152b531bdd98a$var$FALLBACK_INTERSECTION_THRESHOLD = 0.5;
class $403152b531bdd98a$export$1799337af8e4206c {
    constructor(cache, trackables, clock){
        this.started = false;
        this.start = ()=>{
            if (this.started) return;
            if (typeof document === 'undefined' || document.body === null || typeof IntersectionObserver === 'undefined' || this.trackables.length === 0) {
                this.started = true;
                return;
            }
            this.started = true;
            this.observedElements = new WeakSet();
            this.observersByThreshold = new Map();
            const getOrCreateObserver = (threshold)=>{
                const existing = this.observersByThreshold?.get(threshold);
                if (existing !== undefined) return existing;
                const observer = new IntersectionObserver((entries)=>{
                    entries.forEach((entry)=>{
                        const elementKey = this.resolveKey(entry.target);
                        if (!elementKey) return;
                        const inView = entry.isIntersecting && entry.intersectionRatio >= threshold && $403152b531bdd98a$var$isElementVisuallyPresent(entry.target);
                        if (inView) (0, $2AizJ.startElementDwellSpan)(this.cache, elementKey, this.clock());
                        else (0, $2AizJ.endElementDwellSpan)(this.cache, elementKey, this.clock());
                    });
                }, {
                    threshold: threshold
                });
                // Guard against a race where stop() ran between constructing the
                // observer and registering it. If the map is gone, disconnect
                // immediately so the observer doesn't leak.
                if (this.observersByThreshold === undefined) {
                    observer.disconnect();
                    return observer;
                }
                this.observersByThreshold.set(threshold, observer);
                return observer;
            };
            const observeElement = (el)=>{
                if (this.observedElements?.has(el)) return;
                this.observedElements?.add(el);
                getOrCreateObserver(this.resolveThresholdForElement(el)).observe(el);
            };
            const scanAndObserve = (root)=>{
                root.querySelectorAll(this.combinedSelector).forEach(observeElement);
            };
            scanAndObserve(document);
            this.mutationObserver = new MutationObserver((mutations)=>{
                for (const mutation of mutations){
                    mutation.addedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            if (node.matches(this.combinedSelector)) observeElement(node);
                            scanAndObserve(node);
                        }
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.closeSpansForSubtree(node);
                            // Remove from the observed set so the element can be
                            // re-observed if it is re-inserted into the DOM later.
                            this.observedElements?.delete(node);
                            node.querySelectorAll(this.combinedSelector).forEach((desc)=>{
                                this.observedElements?.delete(desc);
                            });
                        }
                    });
                    if (mutation.type === 'attributes' && mutation.target instanceof Element) {
                        const el = mutation.target;
                        if (!$403152b531bdd98a$var$isElementVisuallyPresent(el)) {
                            // Close the target element itself (if tracked).
                            const elementKey = this.resolveKey(el);
                            if (elementKey) (0, $2AizJ.endElementDwellSpan)(this.cache, elementKey, this.clock());
                            // Also close any tracked descendants that are now
                            // hidden by this ancestor's attribute change (e.g. a
                            // parent gains class="hidden" or style="display:none").
                            el.querySelectorAll(this.combinedSelector).forEach((desc)=>{
                                const key = this.resolveKey(desc);
                                if (key) (0, $2AizJ.endElementDwellSpan)(this.cache, key, this.clock());
                            });
                        }
                    }
                }
            });
            this.mutationObserver.observe(document.body, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: [
                    'style',
                    'class',
                    'hidden'
                ]
            });
        };
        this.stop = ()=>{
            if (!this.started) return;
            this.started = false;
            this.observersByThreshold?.forEach((observer)=>observer.disconnect());
            this.observersByThreshold?.clear();
            this.observersByThreshold = undefined;
            this.mutationObserver?.disconnect();
            this.mutationObserver = undefined;
            this.observedElements = undefined;
        };
        // Resolve `el`'s dwell key from the first trackability config whose
        // selector it matches and whose `getKey` returns a non-empty key.
        this.resolveKey = (el)=>{
            for (const trackable of this.trackables)if (el.matches(trackable.selector)) {
                const key = trackable.getKey(el);
                if (key) return key;
            }
            return null;
        };
        // Resolve `el`'s intersection threshold from the first trackability config
        // whose selector it matches.
        this.resolveThresholdForElement = (el)=>{
            for (const trackable of this.trackables){
                if (el.matches(trackable.selector)) return $403152b531bdd98a$var$resolveThreshold(trackable, el);
            }
            return $403152b531bdd98a$var$FALLBACK_INTERSECTION_THRESHOLD;
        };
        // For every trackable element in (and including) `root`, close its active
        // dwell span at the current time. Used when DOM nodes are removed so
        // their open spans don't bleed past their lifetime.
        this.closeSpansForSubtree = (root)=>{
            if (root.matches(this.combinedSelector)) {
                const key = this.resolveKey(root);
                if (key) (0, $2AizJ.endElementDwellSpan)(this.cache, key, this.clock());
            }
            root.querySelectorAll(this.combinedSelector).forEach((descendant)=>{
                const key = this.resolveKey(descendant);
                if (key) (0, $2AizJ.endElementDwellSpan)(this.cache, key, this.clock());
            });
        };
        this.cache = cache;
        this.trackables = trackables;
        this.combinedSelector = trackables.map((trackable)=>trackable.selector).join(', ');
        this.clock = clock;
    }
}
// Resolve `trackable.intersectionThreshold` (number or per-element function)
// for `el`, clamped to [0, 1]. Falls back to `FALLBACK_INTERSECTION_THRESHOLD`
// for non-finite values.
function $403152b531bdd98a$var$resolveThreshold(trackable, el) {
    const raw = typeof trackable.intersectionThreshold === 'function' ? trackable.intersectionThreshold(el) : trackable.intersectionThreshold;
    if (!Number.isFinite(raw)) return $403152b531bdd98a$var$FALLBACK_INTERSECTION_THRESHOLD;
    return Math.max(0, Math.min(1, raw));
}
// Return true only if the element is connected to the DOM and not hidden
// via `display: none` or `visibility: hidden` (we treat both as out-of-view).
function $403152b531bdd98a$var$isElementVisuallyPresent(el) {
    if (!el.isConnected) return false;
    if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') return true;
    const style = window.getComputedStyle(el);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    return true;
}

});
parcelRegister("2AizJ", function(module, exports) {
$parcel$export(module.exports, "createElementDwellSpansCache", function () { return $fc45eef392a153a9$export$fada37894f4edf3b; });
$parcel$export(module.exports, "startElementDwellSpan", function () { return $fc45eef392a153a9$export$17a3da773210417; });
$parcel$export(module.exports, "endElementDwellSpan", function () { return $fc45eef392a153a9$export$bb6f6e97e932a4ec; });
$parcel$export(module.exports, "getElementDwellTimes", function () { return $fc45eef392a153a9$export$d63a0bb326060cae; });
$parcel$export(module.exports, "rolloverActiveElementDwellSpans", function () { return $fc45eef392a153a9$export$8bda0eeedd759d0b; });
function $fc45eef392a153a9$export$fada37894f4edf3b() {
    return {
        active: {},
        completed: []
    };
}
function $fc45eef392a153a9$export$17a3da773210417(cache, elementKey, timestamp) {
    if (cache.active[elementKey] !== undefined) return;
    cache.active[elementKey] = timestamp;
}
function $fc45eef392a153a9$export$bb6f6e97e932a4ec(cache, elementKey, timestamp) {
    const entranceTimestamp = cache.active[elementKey];
    if (entranceTimestamp === undefined) return;
    cache.completed.push({
        elementKey: elementKey,
        entranceTimestamp: entranceTimestamp,
        exitTimestamp: timestamp
    });
    delete cache.active[elementKey];
}
function $fc45eef392a153a9$export$d63a0bb326060cae(cache, intervalEndTimestamp) {
    const durations = {};
    cache.completed.forEach((span)=>{
        const duration = Math.max(0, span.exitTimestamp - span.entranceTimestamp);
        durations[span.elementKey] = (durations[span.elementKey] || 0) + duration;
    });
    for(const elementKey in cache.active){
        const entranceTimestamp = cache.active[elementKey];
        if (entranceTimestamp === undefined) continue;
        const duration = Math.max(0, intervalEndTimestamp - entranceTimestamp);
        durations[elementKey] = (durations[elementKey] || 0) + duration;
    }
    return durations;
}
function $fc45eef392a153a9$export$8bda0eeedd759d0b(cache, nextIntervalStartTimestamp) {
    cache.completed = [];
    for(const elementKey in cache.active)cache.active[elementKey] = nextIntervalStartTimestamp;
}
function $fc45eef392a153a9$export$61aae54d8f61a65c(cache) {
    cache.active = {};
    cache.completed = [];
}

});


parcelRegister("g14wK", function(module, exports) {
$parcel$export(module.exports, "IdlePoller", function () { return $05d40f2ca48b1c04$export$d8019e1f9862be37; });

var $jewWt = parcelRequire("jewWt");
class $05d40f2ca48b1c04$export$d8019e1f9862be37 {
    constructor(state, opts){
        this.started = false;
        this.lastSeenIdle = false;
        this.start = ()=>{
            if (this.started) return;
            this.started = true;
            this.lastSeenIdle = this.state.isIdle;
            this.intervalId = setInterval(()=>{
                const nowIdle = (0, $jewWt.updateIdleStateAt)(this.state, this.opts.clock(), this.opts.idleTimeoutMs);
                if (nowIdle && !this.lastSeenIdle) {
                    this.lastSeenIdle = true;
                    this.opts.onIdle();
                } else if (!nowIdle && this.lastSeenIdle) {
                    this.lastSeenIdle = false;
                    this.opts.onActive?.();
                }
            }, this.pollIntervalMs);
        };
        this.stop = ()=>{
            if (!this.started) return;
            this.started = false;
            if (this.intervalId !== undefined) {
                clearInterval(this.intervalId);
                this.intervalId = undefined;
            }
        };
        this.state = state;
        this.opts = opts;
        this.pollIntervalMs = opts.pollIntervalMs ?? 5000;
    }
}

});

parcelRegister("76bMJ", function(module, exports) {
$parcel$export(module.exports, "IntervalLoop", function () { return $fc3080c7d828a680$export$4843df8b035b2e8f; });

var $cyd5Y = parcelRequire("cyd5Y");
class $fc3080c7d828a680$export$4843df8b035b2e8f {
    constructor(schedule, cursor, onTick){
        this.started = false;
        this.start = ()=>{
            if (this.started) return;
            this.started = true;
            this.scheduleNext();
        };
        this.stop = ()=>{
            if (!this.started) return;
            this.started = false;
            if (this.timeoutId !== undefined) {
                clearTimeout(this.timeoutId);
                this.timeoutId = undefined;
            }
        };
        this.scheduleNext = ()=>{
            if (!this.started) return;
            const ms = (0, $cyd5Y.peekNextIntervalDurationMs)(this.schedule, this.cursor);
            this.timeoutId = setTimeout(()=>{
                if (!this.started) return;
                const consumedStep = (0, $cyd5Y.advanceIntervalScheduleCursor)(this.cursor);
                try {
                    this.onTick(consumedStep);
                } finally{
                    this.scheduleNext();
                }
            }, ms);
        };
        this.schedule = schedule;
        this.cursor = cursor;
        this.onTick = onTick;
    }
}

});
parcelRegister("cyd5Y", function(module, exports) {
$parcel$export(module.exports, "createIntervalScheduleCursor", function () { return $89989f888969848a$export$23c88cfa91f0da2e; });
$parcel$export(module.exports, "resetIntervalScheduleCursor", function () { return $89989f888969848a$export$fbd240badd5ad566; });
$parcel$export(module.exports, "advanceIntervalScheduleCursor", function () { return $89989f888969848a$export$a419cb2db33bebb4; });
$parcel$export(module.exports, "peekNextIntervalDurationMs", function () { return $89989f888969848a$export$a2a4539200c45474; });
function $89989f888969848a$export$23c88cfa91f0da2e() {
    return {
        stepIndex: 0
    };
}
function $89989f888969848a$export$fbd240badd5ad566(cursor) {
    cursor.stepIndex = 0;
}
function $89989f888969848a$export$a419cb2db33bebb4(cursor) {
    const consumed = cursor.stepIndex;
    cursor.stepIndex = consumed + 1;
    return consumed;
}
function $89989f888969848a$export$c427f03ab1864dc8(schedule, stepIndex) {
    if ('interval' in schedule) return $89989f888969848a$var$secondsToMs(schedule.interval);
    const list = schedule.intervals;
    if (list.length === 0) throw new Error('`intervals` must contain at least one value.');
    const idx = Math.min(Math.max(stepIndex, 0), list.length - 1);
    const seconds = list[idx];
    if (seconds === undefined) throw new Error('`intervals` must contain at least one value.');
    return $89989f888969848a$var$secondsToMs(seconds);
}
function $89989f888969848a$export$a2a4539200c45474(schedule, cursor) {
    return $89989f888969848a$export$c427f03ab1864dc8(schedule, cursor.stepIndex);
}
function $89989f888969848a$var$secondsToMs(seconds) {
    if (!Number.isFinite(seconds) || seconds <= 0) throw new Error(`Dwell interval must be a positive finite number of seconds (got ${seconds}).`);
    return Math.floor(seconds * 1000);
}

});


parcelRegister("3yqd8", function(module, exports) {
$parcel$export(module.exports, "defaultTrackability", function () { return $d44fa04671d8a944$export$69b0bc67dc7bbfe9; });
// Describes which DOM elements are dwell-trackable, how to derive their
// identifier, and what intersection-observer threshold each one uses.
// `selector` drives bulk-discovery via querySelectorAll. `getKey` returns
// the per-element id (or null to skip). `intersectionThreshold` is the
// 0–1 ratio of element area that must be in view to count as visible;
// supply a function to vary per element.
const $d44fa04671d8a944$export$69b0bc67dc7bbfe9 = {
    selector: '[data-dwell-id]',
    getKey: (el)=>el.getAttribute('data-dwell-id'),
    // Consider an element "in view" as soon as any part of it enters the
    // viewport. IntersectionObserver fires when `intersectionRatio > 0`.
    // This is because we need to fix some issues with the in-view threshold logic
    intersectionThreshold: 0
};

});

parcelRegister("9XWaQ", function(module, exports) {
$parcel$export(module.exports, "getEmitPayload", function () { return $7174aa8f60898700$export$186716f2172e66f6; });

var $2AizJ = parcelRequire("2AizJ");

var $kxdeC = parcelRequire("kxdeC");
function $7174aa8f60898700$export$186716f2172e66f6(sessionState, spansCache, intervalEndedAt, stepIndex) {
    const sessionId = (0, $kxdeC.getDwellSessionId)(sessionState);
    if (sessionId === null || sessionState.startedAt === null) return null;
    const durationsMs = (0, $2AizJ.getElementDwellTimes)(spansCache, intervalEndedAt);
    // Convert internal ms durations to seconds for the public payload.
    const durations = {};
    for(const key in durationsMs){
        const ms = durationsMs[key];
        if (ms !== undefined) durations[key] = ms / 1000;
    }
    return {
        sessionId: sessionId,
        sessionStartedAt: sessionState.startedAt,
        intervalEndedAt: intervalEndedAt,
        stepIndex: stepIndex,
        durations: durations
    };
}

});
parcelRegister("kxdeC", function(module, exports) {
$parcel$export(module.exports, "createDwellSessionState", function () { return $bb3bf7761d71d0a0$export$7b94a9ed909b49bd; });
$parcel$export(module.exports, "startDwellSession", function () { return $bb3bf7761d71d0a0$export$2f053a6b59709595; });
$parcel$export(module.exports, "endDwellSession", function () { return $bb3bf7761d71d0a0$export$908db22b48fb6b0b; });
$parcel$export(module.exports, "isDwellSessionActive", function () { return $bb3bf7761d71d0a0$export$260cc7330d5a853a; });
$parcel$export(module.exports, "getDwellSessionId", function () { return $bb3bf7761d71d0a0$export$bab02fdc122d0d3; });
function $bb3bf7761d71d0a0$export$7b94a9ed909b49bd() {
    return {
        id: null,
        startedAt: null
    };
}
function $bb3bf7761d71d0a0$export$2f053a6b59709595(state, id, timestamp) {
    if (state.id !== null) return;
    state.id = id;
    state.startedAt = timestamp;
}
function $bb3bf7761d71d0a0$export$908db22b48fb6b0b(state) {
    state.id = null;
    state.startedAt = null;
}
function $bb3bf7761d71d0a0$export$260cc7330d5a853a(state) {
    return state.id !== null;
}
function $bb3bf7761d71d0a0$export$bab02fdc122d0d3(state) {
    return state.id;
}

});


parcelRegister("dfN1H", function(module, exports) {
$parcel$export(module.exports, "generateSessionId", function () { return $cb300a478b7bfd99$export$e0d7d8f108b2bd0b; });
function $cb300a478b7bfd99$export$e0d7d8f108b2bd0b() {
    if (typeof globalThis !== 'undefined' && globalThis.crypto && typeof globalThis.crypto.randomUUID === 'function') return globalThis.crypto.randomUUID();
    return `dwell-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

});



parcelRegister("aT8t4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $779847b443bf05b9$export$2e2bcd8739ae039; });
/* price-calculator.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $4G0xh = parcelRequire("4G0xh");

var $kbpa7 = parcelRequire("kbpa7");

var $8bW04 = parcelRequire("8bW04");

var $iHcWb = parcelRequire("iHcWb");

var $gJe05 = parcelRequire("gJe05");

var $44bDI = parcelRequire("44bDI");

var $MgH7i = parcelRequire("MgH7i");

var $5TIjy = parcelRequire("5TIjy");

var $lc7EO = parcelRequire("lc7EO");

var $fEBe5 = parcelRequire("fEBe5");

var $aLva8 = parcelRequire("aLva8");

var $fhn1A = parcelRequire("fhn1A");

var $9evy5 = parcelRequire("9evy5");

var $juRep = parcelRequire("juRep");
const $779847b443bf05b9$var$RecommendationTracker = ({ plan: plan, index: index, onRecommendedChange: onRecommendedChange })=>{
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: plan.fields.sku
    });
    (0, $1oC0p.useEffect)(()=>{
        onRecommendedChange(index, state.recommended);
    }, [
        index,
        state.recommended,
        onRecommendedChange
    ]);
    return null;
};
const $779847b443bf05b9$var$PricingCalculatorContent = ({ comparePlansData: comparePlansData, urlSlug: urlSlug, selectedCardIndex: selectedCardIndex, setSelectedCardIndex: setSelectedCardIndex, disclaimer: disclaimer, omitInputs: omitInputs, numSections: numSections })=>{
    const intl = (0, $8e22h.default)();
    const handleRecommendedChange = (0, $1oC0p.useCallback)((index, isRecommended)=>{
        if (isRecommended) setSelectedCardIndex(index);
    }, [
        setSelectedCardIndex
    ]);
    const unitsLabel = $779847b443bf05b9$var$useUnitsLabel(comparePlansData);
    const dwellTimeAttributes = (0, $iHcWb.useDwellTimeElementAttributes)({
        id: 'pricing-calculator'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ...dwellTimeAttributes,
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            comparePlansData.length > 1 && comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($779847b443bf05b9$var$RecommendationTracker, {
                    plan: planData,
                    index: index,
                    onRecommendedChange: handleRecommendedChange
                }, `tracker-${planData.fields.sku}`)),
            !omitInputs && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $MgH7i.PricingCalculatorInputs), {
                unitCountLabel: intl.formatMessage($9evy5.units.teamSizePrompt),
                unitsLabel: unitsLabel,
                dataProductKey: (0, $4G0xh.urlSlugToDataProductKey)[urlSlug]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8bW04.PricingCards), {
                // must set the number of sections here if removing the bottom section
                // could also infer this from planData's getFeaturesList(fields.highlightedFeaturesContainer)
                numSections: numSections,
                selectedCardIndex: selectedCardIndex ? selectedCardIndex + 1 : 1,
                children: comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $juRep.PricingCalculatorCard), {
                        showBannerText: comparePlansData.length > 1,
                        planData: planData,
                        urlSlug: urlSlug,
                        index: index,
                        isSingleCard: comparePlansData.length === 1
                    }, planData.fields.sku))
            }),
            disclaimer && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_p12frdnh _k48p1nn1 _vwz4gktf _1wybdlk8 _syaz1pfd _1yt4utpp _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    },
                    children: disclaimer
                })
            })
        ]
    });
};
const $779847b443bf05b9$var$disclaimerContainerCss = null;
const $779847b443bf05b9$var$disclaimerCss = null;
const $779847b443bf05b9$var$DEFAULT_SELECTED_CARD_INDEX = 2;
const $779847b443bf05b9$var$UniformPricingCalculator = (props)=>{
    const { urlSlug: urlSlug, disclaimer: disclaimer, inputs: inputs, onChangeInputs: onChangeInputs, getDiscountedPrice: getDiscountedPrice, comparePlansData: comparePlansData, configOverrides: configOverrides } = props;
    // GWP-10907: JPD-specific decision (urlSlug + FF) about whether to strip
    // each plan's `highlightedFeaturesContainer` BEFORE we compute
    // `numSections` and render any cards. The hook itself owns the JPD-only
    // `urlSlug === "product-discovery"` check, so this shared calculator no
    // longer has to know about JPD product semantics. For every non-JPD
    // product the hook returns `false` and the sanitizer is a no-op.
    const shouldStripJpdHighlightedFeatures = (0, $lc7EO.useShouldStripJpdHighlightedFeatures)(urlSlug);
    const [selectedCardIndex, setSelectedCardIndex] = (0, $1oC0p.useState)($779847b443bf05b9$var$DEFAULT_SELECTED_CARD_INDEX);
    const providerResult = (0, $fhn1A.useProviderProps)({
        plans: comparePlansData,
        product: urlSlug,
        inputValues: inputs
    });
    if (providerResult.status === 'pending') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5TIjy.LoadingSpinner), {});
    if (providerResult.status === 'error') return null; // todo: fire an event @bsparks GWP-6943
    if (providerResult.status !== 'ready') return null; // this should never happen due to checks above, but fixes type error
    const { config: baseConfig, inputValues: inputValues } = providerResult.props;
    // Apply configOverrides if provided (e.g., for nonprofit custom recommendation limits)
    const config = configOverrides ? {
        ...baseConfig,
        ...configOverrides
    } : baseConfig;
    // Resilience guard: drop any plan whose SKU is not represented in the
    // code-side `planLimitConfigs`. Downstream selectors (e.g.
    // `getPlanLimitConfig` in selectors.ts) throw on unknown SKUs, which
    // would crash the entire pricing page via the error boundary. This
    // lets CMS authors stage a new plan/SKU in Contentful before the
    // corresponding code-side limit config exists, without breaking the
    // live page. Once a `planLimitConfigs` entry is added for the SKU the
    // plan will start rendering automatically.
    //
    // For JPD this is also the mechanism that gates the new Enterprise
    // SKU rollout (GWP-10907): when the feature flag is off,
    // `useJpdPlanLimitConfigs()` (in `mappings.ts`) excludes the
    // Enterprise entry, so this guard automatically filters the matching
    // CMS plan out.
    const knownSkus = new Set(config.planLimitConfigs.map((plan)=>plan.offeringSku));
    const skippedSkus = comparePlansData.filter((plan)=>!knownSkus.has(plan.fields.sku)).map((plan)=>plan.fields.sku);
    if (skippedSkus.length > 0) // eslint-disable-next-line no-console
    console.warn(`[UniformPricingCalculator] Skipping plan(s) with SKUs not present in planLimitConfigs for "${urlSlug}": ${skippedSkus.join(', ')}. Add them to the corresponding *.pricing-calculator-config.ts to render.`);
    // Drop unknown SKUs first (resilience guard above), then — for JPD with
    // the highlighted-features FF off — strip the per-card highlighted-
    // features content via the JPD-owned sanitizer. For every non-JPD
    // product `shouldStripJpdHighlightedFeatures` is `false`, so the
    // `stripJpdHighlightedFeatures` call is skipped entirely and the
    // filtered `comparePlansData` flows through unchanged.
    const filteredComparePlansData = comparePlansData.filter((plan)=>knownSkus.has(plan.fields.sku));
    const sanitizedComparePlansData = shouldStripJpdHighlightedFeatures ? (0, $lc7EO.stripJpdHighlightedFeatures)(filteredComparePlansData) : filteredComparePlansData;
    const numSections = (0, $44bDI.getFeaturesList)(sanitizedComparePlansData?.[0]?.fields?.highlightedFeaturesContainer) === undefined ? 1 : 2;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aLva8.PricingCalculatorContextProvider), {
        config: config,
        inputValues: inputValues,
        onChangeInputs: onChangeInputs,
        getDiscountedPrice: getDiscountedPrice,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($779847b443bf05b9$var$PricingCalculatorContent, {
            comparePlansData: sanitizedComparePlansData,
            urlSlug: urlSlug,
            selectedCardIndex: selectedCardIndex,
            setSelectedCardIndex: setSelectedCardIndex,
            disclaimer: disclaimer,
            numSections: numSections,
            omitInputs: !config.billingCycleConfig.monthly && !config.billingCycleConfig.annual
        })
    });
};
var $779847b443bf05b9$export$2e2bcd8739ae039 = $779847b443bf05b9$var$UniformPricingCalculator;
function $779847b443bf05b9$var$useUnitsLabel(comparePlansData) {
    const intl = (0, $8e22h.default)();
    const hasAgents = comparePlansData.some((plan)=>{
        return [
            (0, $fEBe5.serviceCollectionOfferingSkus).free,
            (0, $fEBe5.serviceCollectionOfferingSkus).standard,
            (0, $fEBe5.serviceCollectionOfferingSkus).premium,
            (0, $fEBe5.serviceCollectionOfferingSkus).enterprise
        ].includes(plan.fields.sku);
    });
    if (hasAgents) return intl.formatMessage($9evy5.units.agentsUnitsLabel);
    return intl.formatMessage($9evy5.units.usersUnitsLabel);
}

});
parcelRegister("4G0xh", function(module, exports) {
$parcel$export(module.exports, "urlSlugToDataProductKey", function () { return $ceccdba2041bfa64$export$9c59efe722f16a54; });
const $ceccdba2041bfa64$export$e36fc9e5c75fc113 = 'jiraSoftware';
const $ceccdba2041bfa64$export$b65b36d21c9a62a9 = 'confluence';
const $ceccdba2041bfa64$export$b24966420407028a = 'strategyCollection';
const $ceccdba2041bfa64$export$46061d552ba374f4 = 'teamworkCollection';
const $ceccdba2041bfa64$export$e7e2043098922532 = 'compass';
const $ceccdba2041bfa64$export$6648fdba742bde2c = 'serviceCollection';
const $ceccdba2041bfa64$export$b3fce742f95b2633 = 'atlassianGuard';
const $ceccdba2041bfa64$export$9c59efe722f16a54 = {
    jira: $ceccdba2041bfa64$export$e36fc9e5c75fc113,
    confluence: $ceccdba2041bfa64$export$b65b36d21c9a62a9,
    strategy: $ceccdba2041bfa64$export$b24966420407028a,
    teamwork: $ceccdba2041bfa64$export$46061d552ba374f4,
    compass: $ceccdba2041bfa64$export$e7e2043098922532,
    service: $ceccdba2041bfa64$export$6648fdba742bde2c,
    guard: $ceccdba2041bfa64$export$b3fce742f95b2633
};

});

parcelRegister("8bW04", function(module, exports) {
$parcel$export(module.exports, "PricingCards", function () { return $6b8bae1d092d0de9$export$eb5ade451900e238; });
/* pricing-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $6b8bae1d092d0de9$export$eb5ade451900e238 = (props)=>{
    const { selectedCardIndex: selectedCardIndex, children: children, numSections: numSections = 2, hasCalloutSlot: hasCalloutSlot, hasRangeSlot: hasRangeSlot, hasLinkSlot: hasLinkSlot, hasBannerSlot: hasBannerSlot } = props;
    const numberOfChildren = (0, $1oC0p.Children).count(children);
    const getBorderProps = (childIndex, numSections)=>{
        if (numSections !== 1) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        return {
            topSectionStyle: {
                borderStartEndRadius: isFirstChild ? '0' : undefined,
                borderEndEndRadius: isFirstChild ? '0px' : undefined,
                borderStartStartRadius: isLastChild ? '0' : undefined,
                borderEndStartRadius: isLastChild ? '0px' : undefined
            }
        };
    };
    const getSelectedBorderProps = (childIndex)=>{
        if (selectedCardIndex === undefined || selectedCardIndex !== childIndex) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        const blackBorder = `1px solid ${(0, $kbpa7.wacToken)('color.primary.black')}`;
        return {
            topSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockStart: blackBorder,
                borderLeftRadius: '10px',
                borderTopRightRadius: numSections === 1 && isLastChild ? '20px' : undefined,
                borderBottomLeftRadius: numSections === 1 && isLastChild ? '0px' : undefined,
                borderBottomRightRadius: numSections === 1 && isFirstChild ? '0px' : undefined,
                borderRadius: numSections === 1 && !isFirstChild && !isLastChild ? `0px` : undefined,
                borderBottom: numSections === 1 ? blackBorder : undefined
            },
            bottomSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockEnd: blackBorder
            }
        };
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_2z054em0 _yv0e1579 _1e0c11p5 _wij21bp4 _1bsb1ns9 _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _glte1ns9 _1ao8kze7 _37tx1hz7 _11nh1hz7 _157nkze7 _1r9zkze7 _qrtggktf _bzkj1o2v _bi301wxo _x3301o2v _1x3d1wxo _1q1tkze7 _qcje1wxo _14bpgktf _uedhpqof _sqhgkze7 _1bs9gktf _1o36gktf _r0rakze7 _23ugkze7 _4ezvkze7",
            numSections !== 1 && "_1aqcftgi",
            "_1mjb1txw _na0i1bp4 _1s4p1osq _1a7ngktf _1xwygktf _9h3lkze7 _9rrkkze7 _18xwkze7",
            numSections === 1 && "_pmhu1txs _ukazftgi _i370kze7 _1635kze7"
        ]),
        style: {
            "--_wcq253": (0, $6ZVlx.default)(numSections),
            "--_1j6te2o": (0, $6ZVlx.default)(numberOfChildren),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
            "--_kx26wc": (0, $6ZVlx.default)(numSections === 1 ? `1px solid ${(0, $kbpa7.wacToken)('color.neutral.light400')}` : undefined),
            "--_pkeca6": (0, $6ZVlx.default)(numSections === 1 ? '0px' : '20px'),
            "--_1gzfxjx": (0, $6ZVlx.default)(numSections === 1 ? '0px' : undefined),
            "--_y7p57n": (0, $6ZVlx.default)(numSections === 1 ? '20px' : undefined)
        },
        children: (0, $1oC0p.Children).map(children, (child, index)=>{
            if (!child) return null;
            return /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, {
                key: index,
                hasCalloutSlot: hasCalloutSlot,
                hasRangeSlot: hasRangeSlot,
                hasLinkSlot: hasLinkSlot,
                hasBannerSlot: hasBannerSlot,
                ...index + 1 === selectedCardIndex ? getSelectedBorderProps(index + 1) : getBorderProps(index + 1, numSections)
            });
        })
    });
};

});

parcelRegister("iHcWb", function(module, exports) {
$parcel$export(module.exports, "useDwellTimeElementAttributes", function () { return $7c1ee2bf8ba3e9b8$export$b0b11b3d5fa9707f; });

var $1oC0p = parcelRequire("1oC0p");

var $hfydu = parcelRequire("hfydu");
function $7c1ee2bf8ba3e9b8$export$b0b11b3d5fa9707f({ id: id }) {
    const context = (0, $1oC0p.useContext)((0, $hfydu.DwellTimeContext));
    return context?.enabled ? {
        'data-dwell-id': id
    } : {};
}

});

parcelRegister("gJe05", function(module, exports) {
$parcel$export(module.exports, "useCalculationState", function () { return $ffe53822942d34d9$export$5ac48a71a65a15bc; });

var $1CtPM = parcelRequire("1CtPM");

var $3V3tC = parcelRequire("3V3tC");
function $ffe53822942d34d9$export$5ac48a71a65a15bc(props) {
    const { offeringSku: offeringSku } = props;
    return {
        billingCycle: (0, $1CtPM.useSelector)($3V3tC.getBillingCycle),
        isUnitCountAboveMaxThreshold: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isUnitCountAboveMaxThreshold(ctx, offeringSku)),
        unitCountMin: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitCountMinThreshold(ctx, offeringSku)),
        isUnitCountBelowMinThreshold: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isUnitCountBelowMinThreshold(ctx, offeringSku)),
        price: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getFormattedPlanPrice(ctx, offeringSku)),
        recommended: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isOfferingRecommended(ctx, offeringSku)),
        unitCount: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitCount(ctx)),
        unitTierLowerBound: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitTierLowerBound(ctx, offeringSku)),
        unitTierUpperBound: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitTierUpperBound(ctx, offeringSku)),
        unitsAvailableInTier: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitsAvailableInTier(ctx, offeringSku)),
        numberFormatLocale: (0, $1CtPM.useSelector)($3V3tC.getNumberFormatLocale)
    };
}

});
parcelRegister("1CtPM", function(module, exports) {
$parcel$export(module.exports, "useUnitCount", function () { return $f242ee1b597a5061$export$856785685ba8098f; });
$parcel$export(module.exports, "useBillingCycle", function () { return $f242ee1b597a5061$export$ada282ac321ec3b9; });
$parcel$export(module.exports, "useSelector", function () { return $f242ee1b597a5061$export$2105062e25df4afe; });
$parcel$export(module.exports, "useCcpPricingData", function () { return $f242ee1b597a5061$export$97374d6e908d2c; });

var $1oC0p = parcelRequire("1oC0p");

var $dkcYJ = parcelRequire("dkcYJ");

var $aLva8 = parcelRequire("aLva8");
function $f242ee1b597a5061$export$856785685ba8098f() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $aLva8.usePricingCalculatorContext)();
    const { unitCount: unitCount } = inputValues;
    const changeUnitCount = (value)=>{
        return changeInputValues({
            unitCount: value
        });
    };
    return [
        unitCount,
        changeUnitCount
    ];
}
function $f242ee1b597a5061$export$ada282ac321ec3b9() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $aLva8.usePricingCalculatorContext)();
    const { billingCycle: billingCycle } = inputValues;
    const changeBillingCycle = (value)=>{
        return changeInputValues({
            billingCycle: value
        });
    };
    return [
        billingCycle,
        changeBillingCycle
    ];
}
function $f242ee1b597a5061$export$f3fe2cc7a9497569() {
    return (0, $aLva8.usePricingCalculatorContext)().calculationResult;
}
const $f242ee1b597a5061$export$2105062e25df4afe = (selector)=>{
    const context = (0, $aLva8.usePricingCalculatorContext)();
    return selector(context);
};
const $f242ee1b597a5061$var$PRODUCT_CATALOG_DELIVERY_KEY = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
const $f242ee1b597a5061$var$PRODUCT_CATALOG_SPACE = "3s3v3nq72la0";
const $f242ee1b597a5061$export$97374d6e908d2c = (props)=>{
    const { offeringSkus: offeringSkus, ssrData: ssrData } = props;
    const { fetchData: fetchData, status: fetchStatus, prices: clientSideData } = (0, $dkcYJ.useCCPPriceFinderData)(offeringSkus, $f242ee1b597a5061$var$PRODUCT_CATALOG_DELIVERY_KEY, $f242ee1b597a5061$var$PRODUCT_CATALOG_SPACE);
    const execFetch = (0, $1oC0p.useCallback)(async ()=>{
        await fetchData();
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if (!ssrData) execFetch();
    }, []);
    const status = $f242ee1b597a5061$var$getCcpPricingDataStatus({
        hasSsrData: !!ssrData,
        fetchStatus: fetchStatus
    });
    return {
        data: ssrData ?? clientSideData,
        status: status
    };
};
function $f242ee1b597a5061$var$getCcpPricingDataStatus(args) {
    const { fetchStatus: fetchStatus, hasSsrData: hasSsrData } = args;
    if (hasSsrData || fetchStatus === 'complete') return 'ready';
    if (fetchStatus === 'idle' || fetchStatus === 'fetching') return 'pending';
    return 'error';
}

});
parcelRegister("aLva8", function(module, exports) {
$parcel$export(module.exports, "usePricingCalculatorContext", function () { return $368a3b873d7337e6$export$cf6d27bb6377cd5b; });
$parcel$export(module.exports, "PricingCalculatorContextProvider", function () { return $368a3b873d7337e6$export$5a79cf764fd87278; });

var $7VQPk = parcelRequire("7VQPk");

var $8cfMz = parcelRequire("8cfMz");

var $5CQu1 = parcelRequire("5CQu1");

var $1oC0p = parcelRequire("1oC0p");
const $368a3b873d7337e6$var$PricingCalculatorContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $368a3b873d7337e6$export$cf6d27bb6377cd5b = ()=>{
    const pricingCalculatorContext = (0, $1oC0p.useContext)($368a3b873d7337e6$var$PricingCalculatorContext);
    if (!pricingCalculatorContext) throw new Error('usePricingCalculatorContext must be used within a PricingCalculatorProvider');
    return pricingCalculatorContext;
};
const $368a3b873d7337e6$export$5a79cf764fd87278 = (props)=>{
    const [inputValues, setInputValues] = (0, $1oC0p.useState)(props.inputValues);
    const calculate = (0, $1oC0p.useCallback)((v)=>{
        const { config: config } = props;
        const productCalculationInputs = (0, $8cfMz.getProductCalculationInputs)(config.planLimitConfigs, config.unitMinEnterprise, v.unitCount, v.billingCycle);
        return (0, $5CQu1.calculateProductPricing)(config.ccpPricingData, productCalculationInputs, config.currencyISOCode, config.localeISOCode);
    }, [
        props
    ]);
    const [calculationResult, setCalculationResult] = (0, $1oC0p.useState)(()=>calculate(inputValues));
    // Recalculate when config (including currency) changes
    (0, $1oC0p.useEffect)(()=>{
        const result = calculate(inputValues);
        setCalculationResult(result);
    }, [
        props.config,
        inputValues,
        calculate
    ]);
    const changeInputValues = (changes)=>{
        const nextValues = {
            ...inputValues,
            ...changes
        };
        setInputValues(nextValues);
        props.onChangeInputs?.(nextValues);
        const result = calculate(nextValues);
        setCalculationResult(result);
        return result;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($368a3b873d7337e6$var$PricingCalculatorContext.Provider, {
        value: {
            inputValues: inputValues,
            changeInputValues: changeInputValues,
            calculationResult: calculationResult,
            config: props.config,
            getDiscountedPrice: props.getDiscountedPrice
        },
        children: props.children
    });
};

});


parcelRegister("3V3tC", function(module, exports) {
$parcel$export(module.exports, "getUnitCount", function () { return $964f907284a6b353$export$f188fc3b389e4986; });
$parcel$export(module.exports, "getBillingCycle", function () { return $964f907284a6b353$export$36cee2c7009ae4b; });
$parcel$export(module.exports, "hasAnnualBilling", function () { return $964f907284a6b353$export$101e70cd0fc05902; });
$parcel$export(module.exports, "hasMonthlyBilling", function () { return $964f907284a6b353$export$9adfa96ec47fe801; });
$parcel$export(module.exports, "isUnitCountAboveMaxThreshold", function () { return $964f907284a6b353$export$bdaa994f7aee683f; });
$parcel$export(module.exports, "getUnitCountMinThreshold", function () { return $964f907284a6b353$export$80145dc7d2cff456; });
$parcel$export(module.exports, "isUnitCountBelowMinThreshold", function () { return $964f907284a6b353$export$5566acad9364293b; });
$parcel$export(module.exports, "getNumberFormatLocale", function () { return $964f907284a6b353$export$3d36f1c8af14c3fb; });
$parcel$export(module.exports, "getCurrencyIsoCode", function () { return $964f907284a6b353$export$5052d5e5b6a90fdc; });
$parcel$export(module.exports, "isOfferingRecommended", function () { return $964f907284a6b353$export$d9589e71fc109cc; });
$parcel$export(module.exports, "getUnitTierLowerBound", function () { return $964f907284a6b353$export$f88112553e09e018; });
$parcel$export(module.exports, "getUnitTierUpperBound", function () { return $964f907284a6b353$export$6f3b3ca7764acc97; });
$parcel$export(module.exports, "getUnitsAvailableInTier", function () { return $964f907284a6b353$export$daa8dd568be987ed; });
$parcel$export(module.exports, "getFormattedPlanPrice", function () { return $964f907284a6b353$export$8808c13548cf959c; });
const $964f907284a6b353$export$f188fc3b389e4986 = (ctx)=>ctx.inputValues.unitCount;
const $964f907284a6b353$export$36cee2c7009ae4b = (ctx)=>ctx.inputValues.billingCycle;
const $964f907284a6b353$export$101e70cd0fc05902 = (ctx)=>{
    return ctx.config.billingCycleConfig.annual;
};
const $964f907284a6b353$export$9adfa96ec47fe801 = (ctx)=>{
    return ctx.config.billingCycleConfig.monthly;
};
const $964f907284a6b353$export$bdaa994f7aee683f = (ctx, offeringSku)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const planLimitConfig = $964f907284a6b353$var$getPlanLimitConfig(ctx, offeringSku);
    return unitCount > planLimitConfig.signupLimit;
};
const $964f907284a6b353$export$80145dc7d2cff456 = (ctx, offeringSku)=>{
    const { minUnitCount: minUnitCount } = $964f907284a6b353$var$getPlanLimitConfig(ctx, offeringSku);
    return minUnitCount ?? 0;
};
const $964f907284a6b353$export$5566acad9364293b = (ctx, offeringSku)=>{
    const minUnitCount = $964f907284a6b353$export$80145dc7d2cff456(ctx, offeringSku);
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    return unitCount < minUnitCount;
};
const $964f907284a6b353$export$3a3e581c62c2c0f = (ctx)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const unitMinEnterprise = ctx.config.unitMinEnterprise;
    return unitCount >= unitMinEnterprise;
};
const $964f907284a6b353$var$getPlanLimitConfigs = (ctx)=>{
    return ctx.config.planLimitConfigs;
};
const $964f907284a6b353$var$getPlanLimitConfig = (ctx, offeringSku)=>{
    const planLimitConfigs = $964f907284a6b353$var$getPlanLimitConfigs(ctx);
    const planLimitConfig = planLimitConfigs.find((plan)=>plan.offeringSku === offeringSku);
    if (!planLimitConfig) throw new Error('unexpected empty value');
    return planLimitConfig;
};
const $964f907284a6b353$var$getPlanPriceResult = (ctx, offeringSku)=>{
    const planPriceResult = ctx.calculationResult.find((plan)=>plan.offeringSku === offeringSku);
    if (!planPriceResult) throw new Error('unexpected empty value');
    return planPriceResult;
};
const $964f907284a6b353$export$e3c7f1437cafb58a = (ctx, offeringSku)=>{
    const price = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    let { totalPrice: totalPrice } = price;
    const { getDiscountedPrice: getDiscountedPrice } = ctx;
    if (getDiscountedPrice) totalPrice = getDiscountedPrice({
        price: totalPrice,
        inputs: ctx.inputValues
    });
    return $964f907284a6b353$export$c86caf1be068fb8d(ctx, totalPrice);
};
const $964f907284a6b353$export$2aabcb5d2a5bee2b = (ctx, offeringSku)=>{
    const { avgPerUnitPrice: avgPerUnitPrice } = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    const { getDiscountedPrice: getDiscountedPrice } = ctx;
    if (getDiscountedPrice) return getDiscountedPrice({
        inputs: ctx.inputValues,
        price: avgPerUnitPrice
    });
    return avgPerUnitPrice;
};
const $964f907284a6b353$export$10818dfc4986524e = (price)=>{
    return Math.round(price);
};
const $964f907284a6b353$export$2dd65b072d3a3106 = (price)=>{
    return Math.ceil(price);
};
const $964f907284a6b353$export$3d36f1c8af14c3fb = (ctx)=>{
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    const isJPY = currencyISOCode === 'JPY';
    return isJPY ? 'ja-JP' : 'en-US';
};
const $964f907284a6b353$export$c86caf1be068fb8d = (ctx, price, options = {})=>{
    const numberFormatLocale = $964f907284a6b353$export$3d36f1c8af14c3fb(ctx);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    return new Intl.NumberFormat(numberFormatLocale, {
        style: 'currency',
        currency: currencyISOCode,
        minimumFractionDigits: options.minimumFractionDigits ?? 0,
        maximumFractionDigits: options.minimumFractionDigits ?? 0
    }).format(price);
};
const $964f907284a6b353$export$b3a0d360c4444407 = (ctx, offeringSku)=>{
    const price = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return price.formattedAvgPerUnitPrice;
};
const $964f907284a6b353$export$d9589e71fc109cc = (ctx, offeringSku)=>{
    const recommendedOfferingSku = $964f907284a6b353$var$getRecommendedOfferingSku(ctx);
    return recommendedOfferingSku === offeringSku;
};
const $964f907284a6b353$var$getRecommendedOfferingSku = (ctx)=>{
    const getRecommendedPlanIdx = (unitCount, minUnitCounts)=>{
        const len = minUnitCounts.length - 1;
        return len - minUnitCounts.reverse().findIndex((minUnitCount)=>unitCount > minUnitCount);
    };
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const planLimitConfigs = $964f907284a6b353$var$getPlanLimitConfigs(ctx);
    const recommendedPlanIdx = getRecommendedPlanIdx(unitCount, planLimitConfigs.map((productPlan)=>productPlan.recommendationLimit));
    return planLimitConfigs[recommendedPlanIdx]?.offeringSku;
};
const $964f907284a6b353$var$getUnformattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.breakdown.at(-1);
};
const $964f907284a6b353$export$f88112553e09e018 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown?.unitLimitLower;
};
const $964f907284a6b353$export$6f3b3ca7764acc97 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown?.unitLimitUpper;
};
const $964f907284a6b353$export$daa8dd568be987ed = (ctx, offeringSku)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const unitTierUpperBound = $964f907284a6b353$export$6f3b3ca7764acc97(ctx, offeringSku);
    return (unitTierUpperBound ?? 0) - unitCount;
};
/**
 * @deprecated
 */ const $964f907284a6b353$var$getFormattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.formattedBreakdown.at(-1);
};
const $964f907284a6b353$export$b1a3e695caa8081d = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown?.formattedUnitLimitLower;
};
const $964f907284a6b353$export$24bf67bcc0364ee6 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown?.formattedUnitLimitUpper;
};
const $964f907284a6b353$export$5052d5e5b6a90fdc = (ctx)=>ctx.config.currencyISOCode;
const $964f907284a6b353$export$8808c13548cf959c = (ctx, offeringSku)=>{
    const billingCycle = $964f907284a6b353$export$36cee2c7009ae4b(ctx);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    if (billingCycle === 'ANNUAL') return $964f907284a6b353$export$e3c7f1437cafb58a(ctx, offeringSku);
    let price = $964f907284a6b353$export$2aabcb5d2a5bee2b(ctx, offeringSku);
    if (currencyISOCode === 'JPY') {
        price = $964f907284a6b353$export$2dd65b072d3a3106(price);
        return $964f907284a6b353$export$c86caf1be068fb8d(ctx, price, {
            minimumFractionDigits: 0
        });
    }
    return $964f907284a6b353$export$c86caf1be068fb8d(ctx, price, {
        minimumFractionDigits: price === 0 || Number.isInteger(price) ? 0 : 2
    });
};
const $964f907284a6b353$export$235d4fbb478dfba0 = (ctx, args)=>{
    const { offeringSku: offeringSku, edition: edition } = args;
    const offering = Object.values(ctx.config.ccpPricingData).find((offering)=>offering.sku === offeringSku);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    const billingCycle = $964f907284a6b353$export$36cee2c7009ae4b(ctx);
    const defaultPricingPlan = offering?.defaultPricingPlans?.filter((item)=>item.currency.toLowerCase() === currencyISOCode.toLowerCase() && item.offeringName.toLowerCase() === edition.toLowerCase() && item.primaryCycle_name.toLowerCase() === billingCycle.toLowerCase() && item.status.toLowerCase() === 'active');
    const lastPricingPlan = defaultPricingPlan?.[defaultPricingPlan.length - 1];
    return lastPricingPlan?.id || '';
};

});


parcelRegister("44bDI", function(module, exports) {
$parcel$export(module.exports, "getFeaturesList", function () { return $b83af44fbf5738a9$export$501f60b80ced167; });
/* features-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $cXZQx = parcelRequire("cXZQx");

var $gVC4y = parcelRequire("gVC4y");
const $b83af44fbf5738a9$export$501f60b80ced167 = (highlightedFeaturesContainer)=>{
    if (!highlightedFeaturesContainer?.length) return undefined;
    return highlightedFeaturesContainer?.map((feature)=>({
            label: feature.fields.highlightedFeatureTitleExternal,
            details: feature.fields.highlightedFeatureDetails && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_q7gqdlk8"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cXZQx.RichTextComponent), {
                    text: (0, $gVC4y.richTextToHTML)(feature.fields.highlightedFeatureDetails)
                })
            }),
            lozengeText: feature.fields.highlightedLabel
        }));
};
const $b83af44fbf5738a9$var$featureDetailsCss = null;

});

parcelRegister("MgH7i", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorInputs", function () { return $884c8db4d1ecaa10$export$8c44531ca473ca22; });
/* pricing-calculator-inputs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $hrGO1 = parcelRequire("hrGO1");

var $4pGAV = parcelRequire("4pGAV");

var $kbpa7 = parcelRequire("kbpa7");

var $1CtPM = parcelRequire("1CtPM");

var $3V3tC = parcelRequire("3V3tC");
const $884c8db4d1ecaa10$export$8c44531ca473ca22 = (props)=>{
    const { unitCountLabel: unitCountLabel, unitsLabel: unitsLabel, dataProductKey: dataProductKey } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [billingCycle, setBillingCycle] = (0, $1CtPM.useBillingCycle)();
    const [unitCount, setUnitCount] = (0, $1CtPM.useUnitCount)();
    const hasMonthlyBilling = (0, $1CtPM.useSelector)($3V3tC.hasMonthlyBilling);
    const hasAnnualBilling = (0, $1CtPM.useSelector)($3V3tC.hasAnnualBilling);
    const [visualUnitCount, setVisualUnitCount] = (0, $1oC0p.useState)(// @ts-ignore
    unitCount);
    (0, $1oC0p.useEffect)(()=>{
        if (visualUnitCount !== '' && visualUnitCount > 0 && !Number.isNaN(visualUnitCount)) // @ts-ignore
        setUnitCount(visualUnitCount);
    }, [
        visualUnitCount
    ]);
    const handleUnitCountChange = (e)=>{
        const stringValue = e.target.value;
        if (stringValue === '') return setVisualUnitCount('');
        // validate max number of digits
        // default is 5
        // TODO: make this configurable
        if (stringValue.length > 6) return;
        const numberValue = parseInt(stringValue, 10);
        if (numberValue < 1) return;
        setVisualUnitCount(numberValue);
    };
    const handleUnitCountBlurChange = ()=>{
        // @ts-ignore
        if (visualUnitCount === '') setVisualUnitCount(unitCount);
        const data = {
            unitCount: unitCount,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: 'ui',
            eventName: `${(0, $hrGO1.TRACKING_EVENT_NAMES).unitTierBox}_blurred`,
            eventComponent: 'input',
            event: 'blurred',
            actionSubject: (0, $hrGO1.TRACKING_EVENT_NAMES).unitTierBox,
            action: 'blurred',
            attributes: data,
            data: data
        }).fire();
    };
    const handleRadioChange = (billingCycle)=>{
        const data = {
            billingCycle: billingCycle,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: 'ui',
            eventName: (0, $hrGO1.TRACKING_EVENT_NAMES).billingCycleChanged,
            eventComponent: 'radioButton',
            event: 'clicked',
            actionSubject: (0, $hrGO1.TRACKING_EVENT_NAMES).billingCycleChanged,
            action: 'clicked',
            attributes: data
        }).fire();
        setBillingCycle(billingCycle);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12fogza"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_p12f1kdj _19pk1wug _2hwx1wug _otyr1wug _18u01wug _b8yq1osq _3wvkidpf _1fbnidpf _1uby1wug _1t0ridpf"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_p12f1kdj _6rth1tcg _181n1txw _b8yq1osq _e8gh1h6o _19wgys9h"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _181n1ule"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: "unit-count",
                                className: (0, $2jatx.default)([
                                    "_ect4z4z1 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_12l2ftgi _syaz1pfd"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                },
                                children: unitCountLabel
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _15flidpf _1d2widpf _1svyidpf _seovidpf _1akoidpf _c7s7idpf _4puvidpf _1r3vidpf _181n116y _1t19kb7n _p7vbkb7n _1rhgf1ug"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    id: "unit-count",
                                    type: "number",
                                    value: visualUnitCount,
                                    onChange: handleUnitCountChange,
                                    onBlur: handleUnitCountBlurChange,
                                    "data-event-component": "inputNumber",
                                    "data-event-container": "priceBlock",
                                    "data-event": "changed",
                                    className: (0, $2jatx.default)([
                                        "_syazalr3 _k48p1nn1 _1wyb1j6v _vwz41tcg _12l214y2 _ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt _1bsb8ved _2rko1y44 _bfhk1hxd _19itglyw _13di444r _jh1sglyw _ji0mglyw"
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: "unit-term",
                                className: (0, $2jatx.default)([
                                    "_syaz1mpp _ect4z4z1 _1wyb1j6v _1dyznl7k _k48p1nn1 _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: unitsLabel
                            })
                        ]
                    }),
                    hasMonthlyBilling && hasAnnualBilling && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4pGAV.RadioButtons), {
                            wrap: false,
                            dataProductKey: dataProductKey,
                            selectedButtonId: billingCycle,
                            onChange: handleRadioChange,
                            groupLabel: /*#__PURE__*/ (0, $7VQPk.jsx)("legend", {
                                className: (0, $2jatx.default)([
                                    "_ect4z4z1 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_1aax1e5h"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "Pricing.priceFinderInputs.billMeText",
                                    defaultMessage: "Bill me:"
                                })
                            }),
                            buttons: [
                                {
                                    id: 'MONTHLY',
                                    label: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "Pricing.priceFinderInputs.monthly",
                                        defaultMessage: "Monthly"
                                    })
                                },
                                {
                                    id: 'ANNUAL',
                                    label: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "Pricing.pricingCalculatorInputs.anually",
                                        defaultMessage: "Annually"
                                    }),
                                    lozenge: {
                                        appearance: 'blue',
                                        text: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "Pricing.pricingCalculatorInputs.saveUpTo",
                                            defaultMessage: "SAVE UP TO 17%"
                                        })
                                    }
                                }
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $884c8db4d1ecaa10$var$labelStyles = null;
const $884c8db4d1ecaa10$var$legendStyles = null;
const $884c8db4d1ecaa10$var$inputTermStyle = null;
const $884c8db4d1ecaa10$var$inputCss = null;

});
parcelRegister("4pGAV", function(module, exports) {
$parcel$export(module.exports, "RadioButtons", function () { return $fce343fe26855c12$export$3f5c08aebfbff744; });
/* radio-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $jE3Ci = parcelRequire("jE3Ci");
const $fce343fe26855c12$var$RadioButton = ({ id: id, label: label, lozenge: lozenge, disabled: disabled = false, checked: checked = false, size: size, handleRadioChange: handleRadioChange })=>{
    const [isChecked, setIsChecked] = (0, $1oC0p.useState)(checked);
    (0, $1oC0p.useEffect)(()=>{
        setIsChecked(checked);
    }, [
        checked
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c116y _1n261q9c _4cvr1h6o _zulpu2gc _1o9zidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                className: (0, $2jatx.default)([
                    "_80omtlke _zulpu2gc _1e0c1txw _4cvr1h6o _syazeipq",
                    disabled && "_80om13gf _syazinbi",
                    'body-md'
                ]),
                htmlFor: id,
                style: {
                    "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                        type: "radio",
                        id: id,
                        "aria-describedby": lozenge ? `${id}-hint` : undefined,
                        "data-testid": `radio-${id}`,
                        checked: isChecked,
                        disabled: disabled,
                        onChange: (e)=>{
                            if (disabled) return;
                            handleRadioChange(e);
                            setIsChecked(!isChecked);
                        },
                        className: (0, $2jatx.default)([
                            "_syaz1r31 _r06hglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19it11a3 _2rko1ssb _80omtlke _1e0c11p5 _ae4v1h6o _1bah1h6o _1ah3v77o _1ygbm8mt _q4zt5hrz _4cvx5hrz _h0k65hrz _1gemb3bt _6sdp1ssb _1ofr1ule _1uv45hrz",
                            size === 'medium' && "_1bsbgktf _4t3igktf _1m1d19bv _rdm219bv",
                            size === 'large' && "_1bsb1f4h _4t3i1f4h _1m1d7vkz _rdm27vkz",
                            disabled && "_80om13gf _syazinbi _1h6dinbi _q4ztinbi _4cvxinbi"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                            "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600'))
                        }
                    }),
                    label
                ]
            }),
            lozenge && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                id: `${id}-hint`,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                    appearance: lozenge.appearance,
                    text: lozenge.text
                })
            })
        ]
    });
};
const $fce343fe26855c12$export$3f5c08aebfbff744 = ({ groupLabel: groupLabel, buttons: buttons, selectedButtonId: selectedButtonId, dataProductKey: // @ts-expect-error existing
// eslint-disable-next-line @typescript-eslint/no-unused-vars
dataProductKey, size: size = 'medium', onChange: onChange, wrap: wrap = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [currentSelectedButtonId, setSelectedButtonId] = (0, $1oC0p.useState)(selectedButtonId);
    // Keep internal selection in sync when the controlling prop changes
    // (e.g. another component in the same context updates the shared
    // billing cycle, where clicking the in-card "Billed annually" link must move the
    // top "Bill me:" radio from Monthly to Annually).
    (0, $1oC0p.useEffect)(()=>{
        setSelectedButtonId(selectedButtonId);
    }, [
        selectedButtonId
    ]);
    const handleRadioChange = (e)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            // eventName: TODO: event name,
            eventComponent: 'radioButton',
            event: 'clicked',
            // actionSubject: TODO: action subject,
            action: 'clicked'
        }).fire();
        setSelectedButtonId(e.target.id);
        if (onChange) onChange(e.target.id);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("fieldset", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _19itglyw _1bsb1osq _zulpxy5q",
            wrap && "_1n261g80"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("legend", {
                className: (0, $2jatx.default)([
                    "_1aax1e5h _o5721q9c _k48pni7l _syazeipq",
                    'body-md'
                ]),
                children: groupLabel
            }),
            buttons.map((button)=>/*#__PURE__*/ (0, $7VQPk.jsx)($fce343fe26855c12$var$RadioButton, {
                    id: button.id,
                    label: button.label,
                    lozenge: button.lozenge,
                    disabled: button.disabled,
                    checked: currentSelectedButtonId === button.id,
                    size: size,
                    handleRadioChange: handleRadioChange
                }, button.id))
        ]
    });
};
const $fce343fe26855c12$var$containerStyles = null;
const $fce343fe26855c12$var$groupLabelStyles = null;
const $fce343fe26855c12$var$radioContainerStyles = null;
const $fce343fe26855c12$var$radioLabelStyles = null;
const $fce343fe26855c12$var$mediumSizeRadioInputStyles = null;
const $fce343fe26855c12$var$largeSizeRadioInputStyles = null;
const $fce343fe26855c12$var$radioInputStyles = null;
const $fce343fe26855c12$var$disabledRadioButtonStyles = null;
const $fce343fe26855c12$var$disabledRadioLabelStyles = null;

});


parcelRegister("5TIjy", function(module, exports) {
$parcel$export(module.exports, "LoadingSpinner", function () { return $5e560a7364105b43$export$b08b517936747730; });
/* spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $7qFQI = parcelRequire("7qFQI");
const $5e560a7364105b43$export$b08b517936747730 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4t3i1ogm _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            role: "alert",
            "aria-label": intl.formatMessage({
                id: 'pricing-calculator.loading',
                defaultMessage: 'Loading'
            }),
            "data-testid": "global-nav-user-profile-container-spinner",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {})
        })
    });
};

});

parcelRegister("fhn1A", function(module, exports) {
$parcel$export(module.exports, "useProviderProps", function () { return $00fd412ee2189aba$export$521c373ccc32c300; });

var $17RBn = parcelRequire("17RBn");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $hu3Tl = parcelRequire("hu3Tl");

var $aTHox = parcelRequire("aTHox");

var $7dhmX = parcelRequire("7dhmX");

var $29JVp = parcelRequire("29JVp");

var $44C4o = parcelRequire("44C4o");

var $j1ORI = parcelRequire("j1ORI");

var $lc7EO = parcelRequire("lc7EO");

var $4utnL = parcelRequire("4utnL");

var $9Nmuw = parcelRequire("9Nmuw");

var $fEBe5 = parcelRequire("fEBe5");

var $hGYMM = parcelRequire("hGYMM");

var $YmHME = parcelRequire("YmHME");

var $1CtPM = parcelRequire("1CtPM");
function $00fd412ee2189aba$export$521c373ccc32c300(props) {
    const { plans: plans, product: product, inputValues: inputValues } = props;
    const billingCycle = inputValues?.billingCycle;
    const unitCount = inputValues?.unitCount;
    const locale = (0, $17RBn.useLocale)();
    const currencyISOCode = (0, $hu3Tl.getCurrencyFromUserLocale)(locale);
    // GWP-10907: single source of truth for which JPD plan-limit configs
    // are active for the current request. Must be called unconditionally
    // at the top per the Rules of Hooks (the result is only USED in the
    // `product === "product-discovery"` branch below).
    const jpdPlanLimitConfigs = $lc7EO.useJpdPlanLimitConfigs();
    let ssrData = plans.reduce((acc, plan)=>{
        if (!plan.pricingPlan) return acc;
        return {
            ...acc,
            [plan.fields.sku]: plan.pricingPlan
        };
    }, {});
    ssrData = Object.keys(ssrData).length === 0 ? undefined : ssrData;
    const { data: ccpPricingData, status: status } = (0, $1CtPM.useCcpPricingData)({
        offeringSkus: plans.map((plan)=>plan.fields.sku),
        ssrData: ssrData
    });
    if (status === 'error') return {
        status: 'error'
    };
    if (status === 'pending') return {
        status: 'pending'
    };
    if (product === 'jira') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $j1ORI.JIRA_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $j1ORI.JIRA_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $j1ORI.jiraPlanLimitConfigs,
                unitMinEnterprise: $j1ORI.JIRA_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === 'confluence') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $29JVp.CONFLUENCE_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $29JVp.CONFLUENCE_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $29JVp.confluencePlanLimitConfigs,
                unitMinEnterprise: $29JVp.CONFLUENCE_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === 'teamwork') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $YmHME.TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $YmHME.TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $YmHME.teamworkCollectionPlanLimitConfigs,
                unitMinEnterprise: $YmHME.TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $YmHME.teamworkCollectionBillingCycleConfig
            }
        }
    };
    if (product === 'guard') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $44C4o.GUARD_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $44C4o.GUARD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $44C4o.guardPlanLimitConfigs,
                unitMinEnterprise: $44C4o.GUARD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $44C4o.guardBillingCycleConfig
            }
        }
    };
    if (product === 'bitbucket') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $aTHox.BITBUCKET_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $aTHox.BITBUCKET_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $aTHox.bitbucketPlanLimitConfigs,
                unitMinEnterprise: $aTHox.BITBUCKET_MIN_ENTERPRISE_USER_COUNT,
                // bitbucket only supports USD
                currencyISOCode: 'USD',
                localeISOCode: locale,
                billingCycleConfig: $aTHox.bitbucketBillingCycleConfig
            }
        }
    };
    if (product === 'strategy') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $hGYMM.STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $hGYMM.STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $hGYMM.strategyCollectionPlanLimitConfigs,
                unitMinEnterprise: $hGYMM.STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $hGYMM.strategyCollectionBillingCycleConfig
            }
        }
    };
    if (product === 'compass') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $7dhmX.COMPASS_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $7dhmX.COMPASS_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $7dhmX.compassPlanLimitConfigs,
                // not sure why this field is necessary
                unitMinEnterprise: $7dhmX.COMPASS_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $7dhmX.compassBillingCycleConfig
            }
        }
    };
    if (product === 'service') {
        const signupLimit = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp11138ServcoPricingIncreaseMaxUsers) ? 100000 : 20000;
        const planLimitConfigs = $fEBe5.serviceCollectionPlanLimitConfigs.map((plan)=>{
            return {
                ...plan,
                signupLimit: signupLimit
            };
        });
        return {
            status: 'ready',
            props: {
                inputValues: {
                    billingCycle: billingCycle ?? $fEBe5.SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE,
                    unitCount: unitCount ?? $fEBe5.SERVICE_COLLECTION_DEFAULT_UNIT_COUNT
                },
                config: {
                    ccpPricingData: ccpPricingData,
                    planLimitConfigs: planLimitConfigs,
                    unitMinEnterprise: $fEBe5.SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                    currencyISOCode: currencyISOCode,
                    localeISOCode: locale,
                    billingCycleConfig: $fEBe5.serviceCollectionBillingCycleConfig
                }
            }
        };
    }
    if (product === 'rovo-dev') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $9Nmuw.ROVO_DEV_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $9Nmuw.ROVO_DEV_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $9Nmuw.rovoDevPlanLimitConfigs,
                unitMinEnterprise: $9Nmuw.ROVO_DEV_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $9Nmuw.rovoDevBillingCycleConfig
            }
        }
    };
    if (product === 'loom') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $4utnL.LOOM_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $4utnL.LOOM_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $4utnL.loomPlanLimitConfigs,
                unitMinEnterprise: $4utnL.LOOM_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $4utnL.loomBillingCycleConfig
            }
        }
    };
    if (product === 'product-discovery') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $lc7EO.JPD_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $lc7EO.JPD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                // Single source of truth for which JPD SKUs are
                // "live" (gated behind the GWP-10907 feature flag).
                // The downstream resilience guard in
                // `UniformPricingCalculator` will filter out any plan
                // whose SKU is not present here, so the Enterprise card
                // is automatically hidden when the FF is off.
                planLimitConfigs: jpdPlanLimitConfigs,
                unitMinEnterprise: $lc7EO.JPD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $lc7EO.jpdBillingCycleConfig
            }
        }
    };
    throw new Error('unknown product');
}

});

parcelRegister("9evy5", function(module, exports) {
$parcel$export(module.exports, "recommended", function () { return $b8ce4f4c86785928$export$bc5b8d0824876806; });
$parcel$export(module.exports, "units", function () { return $b8ce4f4c86785928$export$fe0319385f0cf5a7; });
$parcel$export(module.exports, "perUserPerMonth", function () { return $b8ce4f4c86785928$export$d8b49137e99effc2; });
$parcel$export(module.exports, "perYear", function () { return $b8ce4f4c86785928$export$5eae4ab34e5b16ae; });
$parcel$export(module.exports, "aboveUnitMaxThreshold", function () { return $b8ce4f4c86785928$export$bf2ba8467ff15aa5; });
$parcel$export(module.exports, "belowUnitMinThreshold", function () { return $b8ce4f4c86785928$export$2e64ce41e89d1e18; });
$parcel$export(module.exports, "billedAnnually", function () { return $b8ce4f4c86785928$export$9e1a6bb525180618; });
$parcel$export(module.exports, "switchToAnnualToViewEnterprise", function () { return $b8ce4f4c86785928$export$3277af2b318f7bfa; });
$parcel$export(module.exports, "enterpriseJpyMessage", function () { return $b8ce4f4c86785928$export$68a1387c7d0a683f; });

var $fnHPc = parcelRequire("fnHPc");
const $b8ce4f4c86785928$export$bc5b8d0824876806 = (0, $fnHPc.defineMessage)({
    id: 'priceFinder.recommended',
    defaultMessage: 'Recommended'
});
const $b8ce4f4c86785928$export$fe0319385f0cf5a7 = (0, $fnHPc.defineMessages)({
    teamSizePrompt: {
        id: 'priceFinder.teamSizePrompt',
        defaultMessage: 'Team Size:'
    },
    usersUnitsLabel: {
        id: 'priceFinder.usersUnitsLabel',
        defaultMessage: 'users'
    },
    agentsUnitsLabel: {
        id: 'priceFinder.agentsUnitsLabel',
        defaultMessage: 'agents'
    }
});
const $b8ce4f4c86785928$export$d8b49137e99effc2 = (0, $fnHPc.defineMessage)({
    id: 'priceFinder.perUnitPerMonth',
    defaultMessage: 'per user / month'
});
const $b8ce4f4c86785928$export$5eae4ab34e5b16ae = (0, $fnHPc.defineMessage)({
    id: 'priceFinder.perYear',
    defaultMessage: 'per year'
});
const $b8ce4f4c86785928$export$bf2ba8467ff15aa5 = (0, $fnHPc.defineMessages)({
    default: {
        id: 'priceFinder.aboveUserMaxThreshold.default',
        defaultMessage: "Your user count exceeds this plan's limit"
    },
    cloudEnterprise: {
        id: 'priceFinder.aboveUserMaxThreshold.cloudEnterprise',
        defaultMessage: 'Talk to our sales team about pricing for Cloud Enterprise'
    },
    agents: {
        id: 'priceFinder.aboveUserMaxThreshold.agents',
        defaultMessage: "Your agent count exceeds this plan's limit"
    },
    specificCount: {
        id: 'priceFinder.aboveUserMaxThreshold.specificCount',
        defaultMessage: 'For teams of more than {lowerLimit}, contact our sales team.'
    },
    creators: {
        id: 'priceFinder.aboveUserMaxThreshold.creators',
        defaultMessage: "Your creator count exceeds this plan's limit"
    }
});
const $b8ce4f4c86785928$export$2e64ce41e89d1e18 = (0, $fnHPc.defineMessages)({
    cloudEnterprise: {
        id: 'priceFinder.belowUnitMinThreshold.cloudEnterprise',
        defaultMessage: 'Enterprise plan pricing is available when you enter {minUnitCount} or more users above'
    }
});
const $b8ce4f4c86785928$export$9e1a6bb525180618 = (0, $fnHPc.defineMessage)({
    id: 'priceFinder.billedAnnually',
    defaultMessage: 'Billed annually.'
});
const $b8ce4f4c86785928$export$3277af2b318f7bfa = (0, $fnHPc.defineMessage)({
    id: 'priceFinder.switchToAnnualToViewEnterprise',
    defaultMessage: 'Switch to Annual billing above to view Enterprise pricing.'
});
const $b8ce4f4c86785928$export$68a1387c7d0a683f = (0, $fnHPc.defineMessage)({
    id: 'priceFinder.enterpriseJpyMessage',
    defaultMessage: 'For pricing details see FAQ below or talk to our sales team'
});

});

parcelRegister("juRep", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorCard", function () { return $1b9806dc7038eb23$export$14072311c149f96f; });

var $7VQPk = parcelRequire("7VQPk");

var $4G0xh = parcelRequire("4G0xh");

var $eCYOL = parcelRequire("eCYOL");

var $1NsjC = parcelRequire("1NsjC");

var $v7O5E = parcelRequire("v7O5E");

var $2Wido = parcelRequire("2Wido");

var $kBDDI = parcelRequire("kBDDI");

var $9hJtd = parcelRequire("9hJtd");

var $aTHox = parcelRequire("aTHox");

var $7dhmX = parcelRequire("7dhmX");

var $29JVp = parcelRequire("29JVp");

var $44C4o = parcelRequire("44C4o");

var $j1ORI = parcelRequire("j1ORI");

var $lc7EO = parcelRequire("lc7EO");

var $4utnL = parcelRequire("4utnL");

var $9Nmuw = parcelRequire("9Nmuw");

var $fEBe5 = parcelRequire("fEBe5");

var $hGYMM = parcelRequire("hGYMM");

var $YmHME = parcelRequire("YmHME");
const $1b9806dc7038eb23$export$14072311c149f96f = (props)=>{
    const sku = props.planData.fields.sku;
    const trackingProductKey = (0, $4G0xh.urlSlugToDataProductKey)[props.urlSlug];
    switch(sku){
        // Free
        case (0, $j1ORI.jiraOfferingSkus).free:
        case (0, $29JVp.confluenceOfferingSkus).free:
        case (0, $YmHME.teamworkCollectionOfferingSkus).free:
        case (0, $7dhmX.compassOfferingSkus).free:
        case (0, $aTHox.bitbucketOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        // Standard
        case (0, $j1ORI.jiraOfferingSkus).standard:
        case (0, $29JVp.confluenceOfferingSkus).standard:
        case (0, $YmHME.teamworkCollectionOfferingSkus).standard:
        case (0, $44C4o.guardOfferingSkus).standard:
        case (0, $7dhmX.compassOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $aTHox.bitbucketOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eCYOL.BitbucketStandardPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        // Premium
        case (0, $j1ORI.jiraOfferingSkus).premium:
        case (0, $29JVp.confluenceOfferingSkus).premium:
        case (0, $YmHME.teamworkCollectionOfferingSkus).premium:
        case (0, $44C4o.guardOfferingSkus).premium:
        case (0, $7dhmX.compassOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $aTHox.bitbucketOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eCYOL.BitbucketPremiumPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        // Enterprise
        case (0, $j1ORI.jiraOfferingSkus).enterprise:
        case (0, $29JVp.confluenceOfferingSkus).enterprise:
        case (0, $YmHME.teamworkCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), {
                ...props
            });
        case (0, $hGYMM.strategyCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), {
                ...props,
                isJpyPriceEnabled: true
            });
        // Custom, for any tier
        case (0, $9Nmuw.rovoDevOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kBDDI.RovoDevStandardPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $fEBe5.serviceCollectionOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionFreePriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $fEBe5.serviceCollectionOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionStandardPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $fEBe5.serviceCollectionOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionPremiumPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $fEBe5.serviceCollectionOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionEnterprisePriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $4utnL.loomOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomFreePriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $4utnL.loomOfferingSkus).business:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomBusinessPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $4utnL.loomOfferingSkus).businessPlusAi:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomBusinessPlusAiPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $4utnL.loomOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomEnterprisePriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $lc7EO.jpdOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NsjC.JiraProductDiscoveryFreePriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $lc7EO.jpdOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NsjC.JiraProductDiscoveryStandardPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $lc7EO.jpdOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NsjC.JiraProductDiscoveryPremiumPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $lc7EO.jpdOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NsjC.JiraProductDiscoveryEnterprisePriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        default:
            // todo: @bsparks GWP-6943 fire an event for unexpected sku
            return null;
    }
};

});
parcelRegister("eCYOL", function(module, exports) {
$parcel$export(module.exports, "BitbucketStandardPriceCard", function () { return $cb5a2cb54b1cfed2$export$3f65201715c64fe0; });
$parcel$export(module.exports, "BitbucketPremiumPriceCard", function () { return $cb5a2cb54b1cfed2$export$3845e26e0454185b; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $aTHox = parcelRequire("aTHox");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");

var $2Wido = parcelRequire("2Wido");
const $cb5a2cb54b1cfed2$export$3f65201715c64fe0 = (props)=>{
    const intl = (0, $8e22h.default)();
    const formattedLimit = intl.formatNumber((0, $aTHox.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), {
        ...props,
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    });
};
const $cb5a2cb54b1cfed2$export$3845e26e0454185b = (props)=>{
    const intl = (0, $8e22h.default)();
    const formattedLimit = intl.formatNumber((0, $aTHox.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), {
        ...props,
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    });
};

});
parcelRegister("iXfHC", function(module, exports) {
$parcel$export(module.exports, "PriceAltContainer", function () { return $886eaf760740e014$export$4e62248194b0727b; });
/* price-alt-container.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");
const $886eaf760740e014$export$4e62248194b0727b = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...props,
        className: (0, $2jatx.default)([
            "_1wybdlk8 _y3gn1h6o"
        ]),
        children: props.children
    });
};
const $886eaf760740e014$var$priceAltTextCss = null;

});

parcelRegister("2Wido", function(module, exports) {
$parcel$export(module.exports, "FreePriceCard", function () { return $fd07704e9f8e1231$export$75a717cafbbb6b29; });
$parcel$export(module.exports, "StandardPriceCard", function () { return $fd07704e9f8e1231$export$b2f3ad255eaef337; });
$parcel$export(module.exports, "PremiumPriceCard", function () { return $fd07704e9f8e1231$export$51a8509266751bd0; });
$parcel$export(module.exports, "EnterprisePriceCard", function () { return $fd07704e9f8e1231$export$ba2214b2dcd26743; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $BSG7c = parcelRequire("BSG7c");

var $2wDsW = parcelRequire("2wDsW");

var $lOlsU = parcelRequire("lOlsU");

var $8HBY7 = parcelRequire("8HBY7");

var $gJe05 = parcelRequire("gJe05");

var $7khdS = parcelRequire("7khdS");

var $9Osbp = parcelRequire("9Osbp");

var $iXfHC = parcelRequire("iXfHC");

var $44bDI = parcelRequire("44bDI");

var $lbUj4 = parcelRequire("lbUj4");

var $1CtPM = parcelRequire("1CtPM");

var $9evy5 = parcelRequire("9evy5");

var $3V3tC = parcelRequire("3V3tC");
function $fd07704e9f8e1231$var$usePriceCardEvents(props) {
    const { productKey: productKey, edition: edition } = props;
    const tryIntent = (0, $2wDsW.useTryIntent)({
        containerId: (0, $BSG7c.PRICE_FINDER_CONTAINER),
        intentType: 'button',
        productKey: productKey,
        edition: edition
    });
    const handleClickCta = (0, $lOlsU.useFirePricingPlanCtaEvent)({
        edition: edition,
        productKey: productKey,
        containerId: (0, $BSG7c.PRICE_FINDER_CONTAINER)
    });
    return {
        onClick: ()=>{
            tryIntent.onClick();
            handleClickCta();
        },
        onKeyDown: tryIntent.onKeyDown
    };
}
const $fd07704e9f8e1231$var$FREE_EDITION = 'free';
const $fd07704e9f8e1231$export$75a717cafbbb6b29 = (props)=>{
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const cta = fields.microCta?.[0]?.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: $fd07704e9f8e1231$var$FREE_EDITION
    });
    const dataEventPropsLabel = `${$fd07704e9f8e1231$var$FREE_EDITION}-get-it-now`;
    const urlWithSignupSource = new URL(ctaUrl, window.location.origin);
    urlWithSignupSource.searchParams.set('signupSource', 'pricing');
    const buttonHref = urlWithSignupSource.toString();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8HBY7.PricingCard), {
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText ?? (state.recommended && intl.formatMessage($9evy5.recommended)),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: state.price,
        hasUnitSlot: true,
        hasRangeSlot: props.hasRangeSlot !== undefined ? props.hasRangeSlot : state.billingCycle === 'ANNUAL',
        buttonText: cta?.ctaButtonText,
        buttonVariant: state.recommended ? 'primary' : 'secondary',
        buttonHref: buttonHref,
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                'data-product-key': props.trackingProductKey,
                'data-event-component': 'linkButton',
                'data-event-container': (0, $BSG7c.PRICE_FINDER_CONTAINER),
                'data-event': 'clicked',
                'data-label': `${dataEventPropsLabel}`,
                'data-label-english': `${dataEventPropsLabel}`
            }
        },
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $fd07704e9f8e1231$var$STANDARD_EDITION = 'standard';
const $fd07704e9f8e1231$var$PREMIUM_EDITION = 'premium';
const $fd07704e9f8e1231$export$b2f3ad255eaef337 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)($fd07704e9f8e1231$var$CommonPriceCard, {
        ...props,
        edition: $fd07704e9f8e1231$var$STANDARD_EDITION
    });
const $fd07704e9f8e1231$export$51a8509266751bd0 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)($fd07704e9f8e1231$var$CommonPriceCard, {
        ...props,
        edition: $fd07704e9f8e1231$var$PREMIUM_EDITION
    });
// eslint-disable-next-line complexity
const $fd07704e9f8e1231$var$CommonPriceCard = (props)=>{
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, tierLabelType: tierLabelType, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const dataEventPropsLabel = `${props.edition}-start-trial`;
    const cta = fields.microCta?.[0]?.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: props.edition
    });
    const priceAltElement = (()=>{
        if (state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined) return props.priceAltElementForAboveMaxThreshold;
        return null;
    })();
    const urlWithSignupSource = new URL(ctaUrl, window.location.origin);
    urlWithSignupSource.searchParams.set('signupSource', 'pricing');
    const buttonHref = urlWithSignupSource.toString();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8HBY7.PricingCard), {
        priceTestid: state.billingCycle === 'ANNUAL' ? 'annual-price' : 'monthly-price',
        hasRangeSlot: state.isUnitCountAboveMaxThreshold && currencyIsoCode === 'JPY' && state.billingCycle === 'ANNUAL',
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText ?? (state.recommended && intl.formatMessage($9evy5.recommended)),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: !state.isUnitCountAboveMaxThreshold && state.price,
        priceAltElement: state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined ? priceAltElement : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.default)
        }),
        unit: state.isUnitCountAboveMaxThreshold ? undefined : state.billingCycle === 'MONTHLY' ? props.monthlyPerUserLabel ?? intl.formatMessage($9evy5.perUserPerMonth) : intl.formatMessage($9evy5.perYear),
        hasUnitSlot: true,
        range: state.billingCycle === 'ANNUAL' && !props.omitRange && !state.isUnitCountAboveMaxThreshold && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        }),
        tooltipContent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        }),
        buttonText: cta?.ctaButtonText,
        buttonHref: buttonHref,
        buttonDisabled: state.isUnitCountAboveMaxThreshold,
        buttonVariant: state.recommended || props.isSingleCard ? 'primary' : 'secondary',
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                'data-product-key': props.trackingProductKey,
                'data-event-component': 'linkButton',
                'data-event-container': (0, $BSG7c.PRICE_FINDER_CONTAINER),
                'data-event': 'clicked',
                'data-label': `${dataEventPropsLabel}`,
                'data-label-english': `${dataEventPropsLabel}`
            }
        },
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $fd07704e9f8e1231$export$ba2214b2dcd26743 = (props)=>{
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, showBannerText: showBannerText = true, isSingleCard: isSingleCard, tierLabelType: tierLabelType, customBannerText: customBannerText, isJpyPriceEnabled: isJpyPriceEnabled } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const [_, changeBillingCycle] = (0, $1CtPM.useBillingCycle)();
    const priceAltElement = (()=>{
        if (props.priceAltElement !== undefined) return props.priceAltElement;
        if (currencyIsoCode === 'JPY' && !isJpyPriceEnabled) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.enterpriseJpyMessage)
        });
        if (state.billingCycle === 'MONTHLY') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: '24px'
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Osbp.MonthlyEnterpriseMessage), {
                switchToAnnual: ()=>changeBillingCycle('ANNUAL')
            })
        });
        if (state.isUnitCountAboveMaxThreshold) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: '48px'
            },
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.cloudEnterprise)
        });
        if (state.isUnitCountBelowMinThreshold) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: '48px'
            },
            children: intl.formatMessage($9evy5.belowUnitMinThreshold.cloudEnterprise, {
                minUnitCount: state.unitCountMin
            })
        });
        return null;
    })();
    const isPriceShown = !state.isUnitCountAboveMaxThreshold && !priceAltElement;
    let price = undefined;
    let range = undefined;
    let tooltipContent = undefined;
    if (isPriceShown) {
        price = state.price;
        range = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        });
        tooltipContent = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        });
    }
    const cta = fields.microCta?.[0]?.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const edition = 'enterprise';
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: edition
    });
    const dataEventPropsLabel = `${edition}-contact-sales`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8HBY7.PricingCard), {
        priceTestid: state.billingCycle === 'ANNUAL' ? 'annual-price' : 'monthly-price',
        hasBannerSlot: true,
        hasRangeSlot: currencyIsoCode === 'JPY' && state.billingCycle === 'ANNUAL',
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText ?? (showBannerText && state.recommended && intl.formatMessage($9evy5.recommended)),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: price,
        priceAltElement: priceAltElement,
        unit: // if a price alt element exists, there should be no unit
        priceAltElement ? undefined : !state.isUnitCountAboveMaxThreshold && !state.isUnitCountBelowMinThreshold ? intl.formatMessage($9evy5.perYear) : undefined,
        range: range,
        hasUnitSlot: // the unbounded text for the price alt element makes the unbounded
        currencyIsoCode === 'JPY',
        tooltipContent: tooltipContent,
        buttonText: cta?.ctaButtonText,
        buttonHref: ctaUrl,
        buttonVariant: state.recommended || isSingleCard ? 'primary' : 'secondary',
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                'data-product-key': props.trackingProductKey,
                'data-event-component': 'linkButton',
                'data-event-container': (0, $BSG7c.PRICE_FINDER_CONTAINER),
                'data-event': 'clicked',
                'data-label': `${dataEventPropsLabel}`,
                'data-label-english': `${dataEventPropsLabel}`
            }
        },
        benefitsTitle: fields.highlightedFeaturesTitle,
        // in order for us to render just the top section fo a pricing card, the contentful data must be empty/undefined
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};

});
parcelRegister("BSG7c", function(module, exports) {
$parcel$export(module.exports, "PRICE_FINDER_CONTAINER", function () { return $d0bc5feae5415d38$export$c5526af38120e3f; });
const $d0bc5feae5415d38$export$c5526af38120e3f = 'priceBlock';

});

parcelRegister("8HBY7", function(module, exports) {
$parcel$export(module.exports, "PricingCard", function () { return $70cbe8f32a7644b5$export$668dae926a178a9f; });
/* pricing-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $gqkLW = parcelRequire("gqkLW");

var $cwszX = parcelRequire("cwszX");

var $lqyi6 = parcelRequire("lqyi6");

var $g3AHF = parcelRequire("g3AHF");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");
const $70cbe8f32a7644b5$export$668dae926a178a9f = (props)=>{
    const { bannerText: bannerText, title: title, unit: unit, range: range, buttonText: buttonText, buttonDisabled: buttonDisabled, benefitsTitle: benefitsTitle, benefits: benefits, buttonVariant: buttonVariant = 'primary', buttonHref: buttonHref, description: description, currencyIsoCode: currencyIsoCode, price: price, priceAltElement: priceAltElement, tooltipContent: tooltipContent, buttonProps: buttonProps, calloutText: calloutText, link: link, linkText: linkText, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, isSingleCard: isSingleCard, hasUnitSlot: hasUnitSlot, hasLinkSlot: hasLinkSlot, hasCalloutSlot: hasCalloutSlot, hasRangeSlot: hasRangeSlot, hasBannerSlot: hasBannerSlot, priceTestid: priceTestid, buttonDataEventProps: buttonDataEventProps, linkDataEventProps: linkDataEventProps } = props;
    const intl = (0, $8e22h.default)();
    const uniqueId = (0, $1oC0p.useId)();
    const titleId = `pricing-card-title-${uniqueId}`;
    const buttonId = `pricing-card-button-${uniqueId}`;
    const linkId = `pricing-card-link-${uniqueId}`;
    const topSectionRecommendedStyles = null;
    const bottomSectionRecommendedStyles = null;
    const topSectionNeutralStyles = null;
    const bottomSectionNeutralStyles = null;
    const containerStyles = null;
    const bottomContainerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1s1g1qsq _5fbc1qsq _1yxn15e8 _1ein15e8 _1ul91wdt",
                    isSingleCard && bannerText && "_mqm2go0a _191wgo0a _t51zgo0a _179r1rns",
                    isSingleCard && !bannerText && "_mqm2kze7 _191wkze7 _t51zkze7 _179r32ve"
                ]),
                style: {
                    ...topSectionStyle,
                    "--_vnkma9": (0, $6ZVlx.default)(isSingleCard ? `${(0, $kbpa7.wacToken)('corner.radius.card')}` : undefined),
                    "--_rfnhaj": (0, $6ZVlx.default)(!benefits ? `${(0, $kbpa7.wacToken)('corner.radius.card')}` : undefined),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1d7trqj": (0, $6ZVlx.default)(!benefits ? `1px solid ${(0, $kbpa7.wacToken)('color.primary.black')}` : undefined),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                    "--_1jl4ikm": (0, $6ZVlx.default)(!benefits ? `1px solid ${(0, $kbpa7.wacToken)('color.neutral.light400')}` : undefined)
                },
                children: [
                    bannerText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_bfhk1pfd _1s1g1kw7 _5fbc1kw7 _ahbq1n1a _12l21n1a"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _1p1dangw",
                                    "body-sm"
                                ]),
                                style: {
                                    // override the color from the typography styles
                                    color: (0, $kbpa7.wacToken)('color.neutral.light0'),
                                    // doesn't map to a type matrix in the design, so override
                                    fontSize: '0.75rem'
                                },
                                children: bannerText
                            })
                        })
                    }) : hasBannerSlot ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1q51v47k"
                        ])
                    }) : null,
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_bozg1ejb _y4ti1ejb _1q511ejb _1e0c1txw _4t3i1osq _2lx21bp4 _4cvr1h6o _40tuoahv _144t1ejb"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _4t3i1osq _1kq31ady"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _4t3i1osq _1egl1ejb"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _2lx21bp4 _1bah1yb4 _4t3i1osq"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                                                    id: titleId,
                                                                    className: (0, $2jatx.default)([
                                                                        "_y3gn1h6o _6rthidpf _1pfhidpf",
                                                                        "h4"
                                                                    ]),
                                                                    children: title
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o",
                                                                        "body-sm"
                                                                    ]),
                                                                    children: description
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    price && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        children: price && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_1wyb1ylp _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q511ejb _y3gn1h6o _k48p1fw0",
                                                                currencyIsoCode === 'JPY' && "_mteo1u1b",
                                                                "pricing-card-price h2"
                                                            ]),
                                                            "data-testid": priceTestid,
                                                            children: price
                                                        })
                                                    }),
                                                    !price && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                                        children: priceAltElement
                                                    })
                                                ]
                                            }),
                                            unit && price && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _85i5khs7",
                                                        "body-sm"
                                                    ]),
                                                    style: {
                                                        "--_eb6eb7": (0, $6ZVlx.default)(range ? undefined : "var(--ds-space-300, 24px)")
                                                    },
                                                    children: unit
                                                })
                                            }),
                                            !unit && hasUnitSlot && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1tke1ady",
                                                    "unit-slot"
                                                ])
                                            }),
                                            range ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c1txw _2lx2vrvc _19pkidpf _2hwxidpf _otyridpf _18u0idpf _85i51ejb"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                            className: (0, $2jatx.default)([
                                                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                                                "body-sm"
                                                            ]),
                                                            children: range
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _4cvr1h6o _1bah1h6o _ahbq1b66"
                                                            ]),
                                                            children: tooltipContent && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gqkLW.default), {
                                                                content: tooltipContent,
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                    role: "img",
                                                                    "aria-label": intl.formatMessage({
                                                                        id: 'pricing-card.tooltip.aria-label',
                                                                        defaultMessage: 'More information'
                                                                    }),
                                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cwszX.InfoIcon), {
                                                                        size: "small"
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }) : hasRangeSlot ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_4t3i1crd _85i51ejb",
                                                    "range-slot"
                                                ])
                                            }) : null,
                                            (calloutText || hasCalloutSlot) && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                                                ]),
                                                children: calloutText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                        className: (0, $2jatx.default)([
                                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _85i51ejb",
                                                            "body-sm"
                                                        ]),
                                                        children: calloutText
                                                    })
                                                }) : hasCalloutSlot ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_85i538v4"
                                                    ])
                                                }) : null
                                            })
                                        ]
                                    }),
                                    buttonText && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                        id: buttonId,
                                        variant: buttonVariant,
                                        size: "small",
                                        isDisabled: buttonDisabled,
                                        href: buttonHref,
                                        target: "_blank",
                                        "data-testid": "cta-button",
                                        ...buttonProps,
                                        className: "pricing-card-button",
                                        ariaLabelledby: `${buttonId} ${titleId}`,
                                        dataEventProps: buttonDataEventProps,
                                        children: buttonText
                                    })
                                ]
                            }),
                            typeof link === 'string' && linkText || typeof link === 'object' ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1q51gktf"
                                ]),
                                children: [
                                    typeof link === 'string' && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                        id: linkId,
                                        href: link,
                                        type: "primary",
                                        text: String(linkText),
                                        "aria-label": String(linkText),
                                        ariaLabelledby: `${linkId} ${titleId}`,
                                        dataEventProps: linkDataEventProps
                                    }),
                                    typeof link === 'object' && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                        children: link
                                    })
                                ]
                            }) : hasLinkSlot ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_26vx1ejb _1tntgktf _1mjbglyw"
                                ]),
                                children: linkText
                            }) : null
                        ]
                    })
                ]
            }),
            benefits && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_2rko15e8 _1yxn1qsq _1ein1qsq",
                    isSingleCard && bannerText && "_179rgo0a _191wgo0a _t51zgo0a",
                    isSingleCard && !bannerText && "_179rkze7 _191wkze7 _t51zkze7"
                ]),
                style: {
                    ...bottomSectionStyle,
                    "--_rfnhaj": (0, $6ZVlx.default)(!benefits ? `${(0, $kbpa7.wacToken)('corner.radius.card')}` : undefined),
                    "--_vnkma9": (0, $6ZVlx.default)(isSingleCard ? `${(0, $kbpa7.wacToken)('corner.radius.card')}` : undefined),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_ahbq1ejb _12l21ejb _mqm2n5xp"
                        ]),
                        style: {
                            "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1yt41ejb _1e0c1txw _zulppxbi _2lx21bp4"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48pni7l _syazeipq",
                                        "body-md"
                                    ]),
                                    children: benefitsTitle
                                })
                            }),
                            benefits?.map(({ label: label, details: details, lozengeText: lozengeText })=>details ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3AHF.Expand), {
                                    label: label,
                                    eventDataName: label,
                                    lozengeText: lozengeText,
                                    children: details
                                }, label) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bozg19zt",
                                            "body-sm"
                                        ]),
                                        children: label
                                    })
                                }, label))
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("7khdS", function(module, exports) {
$parcel$export(module.exports, "useLocalizedCtaUrl", function () { return $85c9ce8b07ea27f8$export$b5e9728b9b8ebe33; });

var $jQ0cd = parcelRequire("jQ0cd");
function $85c9ce8b07ea27f8$export$b5e9728b9b8ebe33(ctaFields) {
    return (0, $jQ0cd.useLocalizedHref)(ctaFields?.ctaUrl ?? '');
}

});

parcelRegister("9Osbp", function(module, exports) {
$parcel$export(module.exports, "MonthlyEnterpriseMessage", function () { return $2abbf2119b6f777e$export$16f86c6a635bb9af; });
/* monthly-enterprise-message.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");
const $2abbf2119b6f777e$export$16f86c6a635bb9af = (props)=>{
    const { switchToAnnual: switchToAnnual } = props;
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'switchToAnnual',
            source: 'pricingCalculator',
            attributes: {
                label: 'billed annually'
            }
        }).fire();
        switchToAnnual();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iXfHC.PriceAltContainer), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handleClick,
                tabIndex: 0,
                className: (0, $2jatx.default)([
                    "_bfhk1j28 _19itidpf _80omtlke _syaz5hrz _ect41kw7 _1wyb1kw7 _vwz4idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l3ftjs"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                },
                children: intl.formatMessage($9evy5.billedAnnually)
            }),
            "\xa0",
            intl.formatMessage($9evy5.switchToAnnualToViewEnterprise)
        ]
    });
};
const $2abbf2119b6f777e$var$buttonCss = null;

});

parcelRegister("lbUj4", function(module, exports) {
$parcel$export(module.exports, "UserTier", function () { return $b9de452da2cf6ac9$export$cd4f9ca719669f8d; });
$parcel$export(module.exports, "UserTierExpanded", function () { return $b9de452da2cf6ac9$export$a4c8408bf932bb2; });
/* user-tier.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iRMRa = parcelRequire("iRMRa");
const $b9de452da2cf6ac9$export$cd4f9ca719669f8d = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, numberFormatLocale: numberFormatLocale = 'en-US', unitType: unitType } = props;
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    if (unitType === 'agent') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "PricingCalculator.agentTier.range",
        defaultMessage: "Agent tier: {lowerLimit} - {upperLimit}",
        values: {
            ...(0, $iRMRa.DEFAULT_VALUES),
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "PriceFunder.userTier.range",
        defaultMessage: "User tier: {lowerLimit} - {upperLimit}",
        values: {
            ...(0, $iRMRa.DEFAULT_VALUES),
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        }
    });
};
const $b9de452da2cf6ac9$export$a4c8408bf932bb2 = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsInTier: unitsInTier, unitsAvailableInTier: unitsAvailableInTier, numberFormatLocale: numberFormatLocale = 'en-US' } = props;
    const intl = (0, $8e22h.default)();
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1wybdlk8 _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.tier),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                    formatNumber(unitLimitLower),
                    " - ",
                    formatNumber(unitLimitUpper)
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.filledSeats),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                    formatNumber(unitsInTier)
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.availableSeats),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                    formatNumber(unitsAvailableInTier)
                ]
            })
        ]
    });
};
const $b9de452da2cf6ac9$var$messages = (0, $fnHPc.defineMessages)({
    tier: {
        id: 'PriceFinder.userTier.tier',
        defaultMessage: 'Tier:'
    },
    filledSeats: {
        id: 'PriceFinder.userTier.filledSeats',
        defaultMessage: 'Filled seats:'
    },
    availableSeats: {
        id: 'PriceFinder.userTier.availableSeats',
        defaultMessage: 'Available seats:'
    }
});

});



parcelRegister("1NsjC", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryFreePriceCard", function () { return $bb1064deffe4f718$export$9301352401a96395; });
$parcel$export(module.exports, "JiraProductDiscoveryStandardPriceCard", function () { return $bb1064deffe4f718$export$f632b4bee5bd80fe; });
$parcel$export(module.exports, "JiraProductDiscoveryPremiumPriceCard", function () { return $bb1064deffe4f718$export$1fb355a43910f211; });
$parcel$export(module.exports, "JiraProductDiscoveryEnterprisePriceCard", function () { return $bb1064deffe4f718$export$df05cdb1f88cc3f9; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");

var $2Wido = parcelRequire("2Wido");
const $bb1064deffe4f718$export$9301352401a96395 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), {
        ...props
    });
};
const $bb1064deffe4f718$export$f632b4bee5bd80fe = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), {
        ...props,
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: 'JiraProductDiscoveryPriceCard.perCreatorPerMonth',
            defaultMessage: 'per creator / month'
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.creators)
        })
    });
};
const $bb1064deffe4f718$export$1fb355a43910f211 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), {
        ...props,
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: 'JiraProductDiscoveryPriceCard.perCreatorPerMonth',
            defaultMessage: 'per creator / month'
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.creators)
        })
    });
};
const $bb1064deffe4f718$export$df05cdb1f88cc3f9 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), {
        ...props
    });
};

});

parcelRegister("v7O5E", function(module, exports) {
$parcel$export(module.exports, "LoomFreePriceCard", function () { return $c7b8be01488760da$export$947796c8957ff6ff; });
$parcel$export(module.exports, "LoomBusinessPriceCard", function () { return $c7b8be01488760da$export$2a7af2744a13b8c2; });
$parcel$export(module.exports, "LoomBusinessPlusAiPriceCard", function () { return $c7b8be01488760da$export$efaf4c20492b36b7; });
$parcel$export(module.exports, "LoomEnterprisePriceCard", function () { return $c7b8be01488760da$export$d88b84b01ca5e441; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $1CtPM = parcelRequire("1CtPM");

var $2Wido = parcelRequire("2Wido");
const $c7b8be01488760da$var$OMIT_TIER_UNIT_THRESHOLD = 26;
const $c7b8be01488760da$export$947796c8957ff6ff = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), {
        ...props,
        omitRange: omitRange,
        hasRangeSlot: omitRange ? false : undefined
    });
};
const $c7b8be01488760da$export$2a7af2744a13b8c2 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), {
        ...props,
        omitRange: omitRange
    });
};
const $c7b8be01488760da$export$efaf4c20492b36b7 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    const intl = (0, $8e22h.default)();
    const customBannerText = intl.formatMessage({
        id: 'LoomBusinessPlusAiPriceCard.mostPopular',
        defaultMessage: 'Most popular'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), {
        ...props,
        omitRange: omitRange,
        customBannerText: customBannerText
    });
};
const $c7b8be01488760da$export$d88b84b01ca5e441 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), {
        ...props,
        omitRange: omitRange,
        priceAltElement: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {})
    });
};
const $c7b8be01488760da$var$useOmitRange = ()=>{
    const [billingCycle] = (0, $1CtPM.useBillingCycle)();
    const [unitCount] = (0, $1CtPM.useUnitCount)();
    return billingCycle === 'ANNUAL' && unitCount < $c7b8be01488760da$var$OMIT_TIER_UNIT_THRESHOLD;
};

});

parcelRegister("kBDDI", function(module, exports) {
$parcel$export(module.exports, "RovoDevStandardPriceCard", function () { return $429cde05ec573ae0$export$f0e8bcb2fb60056a; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $2Wido = parcelRequire("2Wido");
const $429cde05ec573ae0$export$f0e8bcb2fb60056a = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), {
        ...props,
        isSingleCard: true,
        monthlyPerUserLabel: intl.formatMessage({
            id: 'RovoDevStandardPriceCard.monthlyPerUserLabel',
            defaultMessage: 'per developer / month'
        })
    });
};

});

parcelRegister("9hJtd", function(module, exports) {
$parcel$export(module.exports, "ServiceCollectionFreePriceCard", function () { return $e9537e62b8dac42c$export$ce09fc7b6ac40092; });
$parcel$export(module.exports, "ServiceCollectionStandardPriceCard", function () { return $e9537e62b8dac42c$export$84affe19123eb209; });
$parcel$export(module.exports, "ServiceCollectionPremiumPriceCard", function () { return $e9537e62b8dac42c$export$1383d1ba03ed3746; });
$parcel$export(module.exports, "ServiceCollectionEnterprisePriceCard", function () { return $e9537e62b8dac42c$export$c277b80f2da61f89; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $2Wido = parcelRequire("2Wido");
const $e9537e62b8dac42c$export$ce09fc7b6ac40092 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), {
        ...props,
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: 'ServiceCollectionPriceCard.perAgentPerMonth',
            defaultMessage: 'per agent / month'
        })
    });
};
const $e9537e62b8dac42c$export$84affe19123eb209 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), {
        ...props,
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: 'ServiceCollectionPriceCard.perAgentPerMonth',
            defaultMessage: 'per agent / month'
        })
    });
};
const $e9537e62b8dac42c$export$1383d1ba03ed3746 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), {
        ...props,
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: 'ServiceCollectionPriceCard.perAgentPerMonth',
            defaultMessage: 'per agent / month'
        })
    });
};
const $e9537e62b8dac42c$export$c277b80f2da61f89 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), {
        ...props,
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: 'ServiceCollectionPriceCard.perAgentPerMonth',
            defaultMessage: 'per agent / month'
        })
    });
};

});




//# sourceMappingURL=confluence-software-anchor-lp-automation.d3903ebf.js.map
